import React, { useState, useEffect, useCallback } from "react";
import Header from "../layouts/Header";
import Footer from "../layouts/Footer";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "../hooks/useAuth";
import { 
  Card, 
  Row, 
  Col, 
  Form, 
  Button, 
  Badge, 
  Modal, 
  Alert, 
  Spinner, 
  Toast, 
  ToastContainer,
  ListGroup,
  Table,
  Tabs,
  Tab,
  Accordion,
  InputGroup,
  Dropdown
} from "react-bootstrap";
import axios from "axios";
import {
  Shield,
  Key,
  CheckCircle,
  XCircle,
  ArrowLeft,
  Save,
  X,
  People,
  Building,
  Lock,
  Unlock,
  FileText,
  ClockHistory,
  Download,
  Eye,
  Plus,
  Trash,
  Pencil,
  Search,
  Filter,
  Globe,
  Person,
  Gear,
  Diagram3,
  ChevronRight,
  ChevronDown,
  ShieldLock,
  ShieldShaded,
  PersonBadge,
  PersonWorkspace,
  Database,
  FileEarmarkText,
  Envelope,
  Telephone,
  Calendar,
  ExclamationTriangle,
  InfoCircle,
  Repeat,
  ExclamationCircle
} from "react-bootstrap-icons";
import { API_BASE_URL } from "../constants/api_constants";

// Configuration de l'API


export default function PermissionsManagement() {
  const navigate = useNavigate();
  const { isAuthenticated, user, loading: authLoading } = useAuth();
  // États principaux
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState(null);
  const [activeTab, setActiveTab] = useState('roles');
  
  // États pour les rôles
  const [roles, setRoles] = useState([]);
  const [selectedRole, setSelectedRole] = useState(null);
  const [roleFormData, setRoleFormData] = useState({
    name: '',
    display_name: '',
    description: '',
    scope: 'local',
    is_system_role: false
  });
  
  // États pour les permissions
  const [permissions, setPermissions] = useState([]);
  const [groupedPermissions, setGroupedPermissions] = useState({});
  const [selectedPermissions, setSelectedPermissions] = useState([]);
  const [permissionFormData, setPermissionFormData] = useState({
    name: '',
    display_name: '',
    description: '',
    group: 'general',
    action: 'access'
  });
  

  // États pour la pagination des permissions
const [currentPage, setCurrentPage] = useState(1);
const [itemsPerPage, setItemsPerPage] = useState(10);
  // États pour les assignments
  const [users, setUsers] = useState([]);
  const [userRoles, setUserRoles] = useState([]);
  const [selectedUser, setSelectedUser] = useState(null);
  const [selectedUserRole, setSelectedUserRole] = useState(null);
const [deprecatedPermissionsList, setDeprecatedPermissionsList] = useState([]);

  // États pour la gestion des permissions
const [permissionsList, setPermissionsList] = useState([]);
const [showCreatePermissionModal, setShowCreatePermissionModal] = useState(false);
const [showEditPermissionModal, setShowEditPermissionModal] = useState(false);
const [showDeletePermissionModal, setShowDeletePermissionModal] = useState(false);
const [selectedPermissionItem, setSelectedPermissionItem] = useState(null);
const [permissionForm, setPermissionForm] = useState({
  name: '',
  description: '',
  status: 'active'  // Ajout du statut
});
const [savingPermission, setSavingPermission] = useState(false);
const [permissionSearchTerm, setPermissionSearchTerm] = useState('');
const [permissionFilterGroup, setPermissionFilterGroup] = useState('all');

// Ajoutez cet état avec les autres useState
const [activePermissionTab, setActivePermissionTab] = useState('all');


const [permissionStatusFilter, setPermissionStatusFilter] = useState('all');

// Modifiez filteredPermissionsList
const filteredPermissionsList = permissionsList.filter(perm => {
  const matchesSearch = permissionSearchTerm === '' || 
    perm.name.toLowerCase().includes(permissionSearchTerm.toLowerCase()) ||
    (perm.description && perm.description.toLowerCase().includes(permissionSearchTerm.toLowerCase()));
  
  const matchesGroup = permissionFilterGroup === 'all' || perm.group === permissionFilterGroup;
  
  const matchesStatus = permissionStatusFilter === 'all' || perm.status === permissionStatusFilter;
  
  return matchesSearch && matchesGroup && matchesStatus;
});

  
  // États pour les modals
  const [showRoleModal, setShowRoleModal] = useState(false);
  const [showPermissionModal, setShowPermissionModal] = useState(false);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [showAssignModal, setShowAssignModal] = useState(false);
  const [showUserPermissionsModal, setShowUserPermissionsModal] = useState(false);
  const [showBulkAssignModal, setShowBulkAssignModal] = useState(false);
  
const [rolesCurrentPage, setRolesCurrentPage] = useState(1);
const [rolesItemsPerPage, setRolesItemsPerPage] = useState(10);



  // États pour le retrait de permissions
const [showRemovePermissionsModal, setShowRemovePermissionsModal] = useState(false);
const [permissionsToRemove, setPermissionsToRemove] = useState([]);
const [removingPermissions, setRemovingPermissions] = useState(false);


  // États pour les formulaires d'édition
  const [editingRole, setEditingRole] = useState(null);
  const [editingPermission, setEditingPermission] = useState(null);
  
  // États pour la recherche et filtres
  const [searchTerm, setSearchTerm] = useState('');
  const [filterScope, setFilterScope] = useState('all');
  const [filterGroup, setFilterGroup] = useState('all');
  // Scope de l'utilisateur connecté
const [userScope, setUserScope] = useState('global');
  // États pour les notifications
  const [notifications, setNotifications] = useState([]);
  const [alertMessage, setAlertMessage] = useState({ show: false, message: '', type: 'info' });
  
  // États pour l'expansion des groupes
  const [expandedGroups, setExpandedGroups] = useState({});
// Ajoutez ces états dans la section des useState (vers le début du fichier)
const [permissionSearchKeyword, setPermissionSearchKeyword] = useState('');
const [permissionCurrentPage, setPermissionCurrentPage] = useState(1);
const [permissionItemsPerPage, setPermissionItemsPerPage] = useState(5);

// Ajoutez ces fonctions après les autres fonctions (vers la ligne 500)
// Filtrer les permissions pour le modal
const getFilteredPermissionsForModal = () => {
  let filtered = [...permissionsList];
  
  if (permissionSearchKeyword) {
    filtered = filtered.filter(perm => 
      perm.name.toLowerCase().includes(permissionSearchKeyword.toLowerCase()) ||
      (perm.display_name && perm.display_name.toLowerCase().includes(permissionSearchKeyword.toLowerCase())) ||
      (perm.description && perm.description.toLowerCase().includes(permissionSearchKeyword.toLowerCase()))
    );
  }
  
  return filtered;
};

// Pagination pour le modal
const getPaginatedPermissions = () => {
  const filtered = getFilteredPermissionsForModal();
  const start = (permissionCurrentPage - 1) * permissionItemsPerPage;
  const end = start + permissionItemsPerPage;
  return {
    items: filtered.slice(start, end),
    total: filtered.length,
    totalPages: Math.ceil(filtered.length / permissionItemsPerPage)
  };
};




// Filtrer les permissions par statut
const getPermissionsByStatus = (status) => {
  return permissionsList.filter(perm => perm.status === status);
};

// Compter les permissions par statut
const getPermissionCountByStatus = (status) => {
  return permissionsList.filter(perm => perm.status === status).length;
};


// Changer de page
const changePermissionPage = (page) => {
  setPermissionCurrentPage(page);
};

// Changer le nombre d'éléments par page
const changePermissionItemsPerPage = (e) => {
  setPermissionItemsPerPage(parseInt(e.target.value));
  setPermissionCurrentPage(1);
};
  // États pour le modal utilisateur
  const [selectedUserForModal, setSelectedUserForModal] = useState(null);
  const [userRolesDetails, setUserRolesDetails] = useState([]);
  const [loadingUserRoles, setLoadingUserRoles] = useState(false);
  const [rolePermissionsMap, setRolePermissionsMap] = useState({});
  const [loadingRolePermissions, setLoadingRolePermissions] = useState(false);
  const [expandedRolePermissions, setExpandedRolePermissions] = useState({});

  const getAuthToken = () => {
    return sessionStorage.getItem("authToken");
  };

  const getHeaders = useCallback(() => {
    const token = getAuthToken();
    const headers = {
      'Content-Type': 'application/json',
      'Accept': 'application/json',
    };

    if (token) {
      headers['Authorization'] = `Bearer ${token}`;
    }

    return headers;
  }, []);

  const hideAlert = useCallback(() => {
    setAlertMessage({ show: false, message: '', type: 'info' });
  }, []);

  const showAlert = useCallback((message, type = 'warning', duration = 5000) => {
    setAlertMessage({ show: true, message, type });

    if (duration > 0) {
      setTimeout(() => hideAlert(), duration);
    }
  }, [hideAlert]);

  const showNotification = (message, type = 'info', duration = 5000) => {
    const id = Date.now();
    const notification = {
      id,
      message,
      type,
      show: true
    };
    
    setNotifications(prev => [notification, ...prev]);
    
    setTimeout(() => {
      hideNotification(id);
    }, duration);
  };

  const hideNotification = (id) => {
    setNotifications(prev => prev.filter(notif => notif.id !== id));
  };


const handleRemovePermissions = async () => {
  if (!selectedRole || permissionsToRemove.length === 0) {
    showAlert("Veuillez sélectionner au moins une permission à retirer", 'warning');
    return;
  }

  setRemovingPermissions(true);

  try {
    const roleId = selectedRole.role_id || selectedRole.id;
    
    console.log('=== RETRAIT DES PERMISSIONS ===');
    console.log('Rôle ID:', roleId);
    console.log('Permissions à retirer (permission_ids):', permissionsToRemove);
    
    const payload = {
      permission_ids: permissionsToRemove
    };
    
    const response = await axios.delete(
      `${API_BASE_URL}/roles/${roleId}/permissions`,
      { 
        headers: getHeaders(),
        data: payload
      }
    );
    
    if (response.data) {
      showNotification(`${permissionsToRemove.length} permission(s) retirée(s) avec succès`, 'success');
      // Fermer le modal
      setShowUserPermissionsModal(false);
      setSelectedRole(null);
      setSelectedPermissions([]);
      setPermissionsToRemove([]);
      await fetchRoles();
      await fetchAllPermissions();
      await fetchDeprecatedPermissions();
    }
  } catch (error) {
    console.error('❌ Erreur retrait des permissions:', error);
    
    let errorMessage = 'Erreur lors du retrait des permissions';
    if (error.response?.data?.message) {
      errorMessage = error.response.data.message;
    } else if (error.response?.data?.error) {
      errorMessage = error.response.data.error;
    }
    
    showAlert(errorMessage, 'danger');
  } finally {
    setRemovingPermissions(false);
  }
};

// Basculer la sélection d'une permission pour le retrait
const togglePermissionToRemove = (permissionId) => {
  const id = typeof permissionId === 'string' ? parseInt(permissionId) : permissionId;
  
  setPermissionsToRemove(prev => {
    if (prev.includes(id)) {
      return prev.filter(p => p !== id);
    } else {
      return [...prev, id];
    }
  });
};


// Récupérer le scope de l'utilisateur connecté
useEffect(() => {
  // Récupérer les infos user depuis sessionStorage ou contexte
  const userStr = sessionStorage.getItem("userData");

  if (userStr) {
    try {
      const user = JSON.parse(userStr);
      if (user?.role?.scope) {
        setUserScope(user.role.scope);
        // Mettre à jour le formulaire avec le scope
        setRoleFormData(prev => ({
          ...prev,
          scope: user.role.scope
        }));
      }
    } catch (error) {
      console.error("Erreur parsing user:", error);
    }
  }
}, []);

// Charger les permissions dépréciées depuis l'API
const fetchDeprecatedPermissions = useCallback(async () => {
  try {
    setLoading(true);
    const response = await axios.get(`${API_BASE_URL}/permissions?status=deprecated`, {
      headers: getHeaders()
    });
    
    let permissionsData = [];
    
    if (Array.isArray(response.data)) {
      permissionsData = response.data;
    } else if (response.data && response.data.data && Array.isArray(response.data.data)) {
      permissionsData = response.data.data;
    }
    
    if (permissionsData.length > 0) {
      const enrichedPermissions = permissionsData.map(perm => ({
        id: perm.id,
        permission_id: perm.permission_id,
        name: perm.name,
        description: perm.description || '',
        display_name: perm.name ? perm.name.replace(/:/g, ' ').replace(/\b\w/g, l => l.toUpperCase()) : '',
        group: perm.name ? (perm.name.split(':')[0] || 'general') : 'general',
        action: perm.name ? (perm.name.split(':')[1] || 'access') : 'access',
        status: perm.status || 'deprecated',
        created_at: perm.created_at,
        updated_at: perm.updated_at
      }));
      
      // Stocker dans un état séparé pour les permissions dépréciées
      setDeprecatedPermissionsList(enrichedPermissions);
    } else {
      setDeprecatedPermissionsList([]);
    }
  } catch (error) {
    console.error('Erreur fetchDeprecatedPermissions:', error);
    setDeprecatedPermissionsList([]);
  } finally {
    setLoading(false);
  }
}, [getHeaders]);

const fetchAllPermissions = useCallback(async () => {
  try {
    setLoading(true);
    const response = await axios.get(`${API_BASE_URL}/permissions`, {
      headers: getHeaders()
    });
    
    let permissionsData = [];
    
    if (Array.isArray(response.data)) {
      permissionsData = response.data;
    } else if (response.data && response.data.data && Array.isArray(response.data.data)) {
      permissionsData = response.data.data;
    }
    
    if (permissionsData.length > 0) {
      const enrichedPermissions = permissionsData.map(perm => ({
        id: perm.id,
        permission_id: perm.permission_id,
        name: perm.name,
        description: perm.description || '',
        display_name: perm.name ? perm.name.replace(/:/g, ' ').replace(/\b\w/g, l => l.toUpperCase()) : '',
        group: perm.name ? (perm.name.split(':')[0] || 'general') : 'general',
        action: perm.name ? (perm.name.split(':')[1] || 'access') : 'access',
        status: perm.status || 'active',  // Récupérer le statut
        created_at: perm.created_at,
        updated_at: perm.updated_at
      }));
      
      setPermissionsList(enrichedPermissions);
    }
  } catch (error) {
    console.error('Erreur fetchAllPermissions:', error);
  } finally {
    setLoading(false);
  }
}, [getHeaders]);

// Créer une nouvelle permission
const handleCreatePermission = async () => {
  if (!permissionForm.name.trim()) {
    showAlert("Le nom de la permission est requis", 'warning');
    return;
  }

  setSavingPermission(true);

  try {
    const payload = {
      name: permissionForm.name.trim().toLowerCase(),
      description: permissionForm.description.trim()
    };

    console.log('Création permission:', payload);

    const response = await axios.post(`${API_BASE_URL}/permissions`, payload, {
      headers: getHeaders()
    });

    if (response.data) {
      showNotification('Permission créée avec succès', 'success');
      setShowCreatePermissionModal(false);
      resetPermissionFormModal();
      await fetchAllPermissions();
      await fetchRoles(); // Recharger les rôles pour mettre à jour la matrice
    } else {
      throw new Error('Erreur lors de la création');
    }
  } catch (error) {
    console.error('Erreur création permission:', error);
    showAlert(`Erreur: ${error.response?.data?.message || error.message}`, 'danger');
  } finally {
    setSavingPermission(false);
  }
};

// Mettre à jour une permission
// Mettre à jour une permission
const handleUpdatePermission = async () => {
  if (!selectedPermissionItem || !permissionForm.name.trim()) {
    showAlert("Le nom de la permission est requis", 'warning');
    return;
  }

  setSavingPermission(true);

  try {
    const payload = {
      name: permissionForm.name.trim().toLowerCase(),
      status: permissionForm.status,  // Ajout du statut
      description: permissionForm.description.trim()
    };

    console.log('Mise à jour permission:', payload);

    const response = await axios.put(
      `${API_BASE_URL}/permissions/${selectedPermissionItem.permission_id}`,
      payload,
      { headers: getHeaders() }
    );

    if (response.data && (response.data.code === 200 || response.status === 200)) {
      showNotification('Permission mise à jour avec succès', 'success');
      setShowEditPermissionModal(false);
      resetPermissionFormModal();
      await fetchAllPermissions();
      await fetchDeprecatedPermissions();
      await fetchRoles(); // Recharger les rôles pour mettre à jour la matrice
    } else {
      throw new Error('Erreur lors de la mise à jour');
    }
  } catch (error) {
    console.error('Erreur mise à jour permission:', error);
    showAlert(`Erreur: ${error.response?.data?.message || error.message}`, 'danger');
  } finally {
    setSavingPermission(false);
  }
};

// Supprimer une permission
const handleDeletePermission = async () => {
  if (!selectedPermissionItem) return;

  setSavingPermission(true);

  console.log(selectedPermissionItem.permission_id);

  try {
    const response = await axios.delete(`${API_BASE_URL}/permissions/${selectedPermissionItem.permission_id}`, {
      headers: getHeaders()
    });

   
      showNotification('Permission supprimée avec succès', 'success');
      setShowDeletePermissionModal(false);
      setSelectedPermissionItem(null);
      await fetchAllPermissions();
      await fetchRoles(); // Recharger les rôles pour mettre à jour la matrice
      await fetchDeprecatedPermissions();
   
  } catch (error) {
    console.error('Erreur suppression permission:', error);
    showAlert(`Erreur: ${error.response?.data?.message || error.message}`, 'danger');
  } finally {
    setSavingPermission(false);
  }
};

// Réinitialiser le formulaire de permission
const resetPermissionFormModal = () => {
  setPermissionForm({
    name: '',
    description: '',
    status: 'active'  // Ajout du statut par défaut
  });
  setSelectedPermissionItem(null);
};
// Ouvrir le modal d'édition
// Ouvrir le modal d'édition
const openEditPermissionModal = (permission) => {
  setSelectedPermissionItem(permission);
  setPermissionForm({
    name: permission.name,
    description: permission.description || '',
    status: permission.status || 'active'  // Ajout du statut
  });
  setShowEditPermissionModal(true);
};
// Filtrer les permissions



// Pagination pour la gestion des permissions
const indexOfLastItem = currentPage * itemsPerPage;
const indexOfFirstItem = indexOfLastItem - itemsPerPage;
const currentItems = filteredPermissionsList.slice(indexOfFirstItem, indexOfLastItem);
const totalPages = Math.ceil(filteredPermissionsList.length / itemsPerPage);

// Fonction pour changer de page
const paginate = (pageNumber) => setCurrentPage(pageNumber);

// Fonction pour changer le nombre d'éléments par page
const handleItemsPerPageChange = (e) => {
  setItemsPerPage(parseInt(e.target.value));
  setCurrentPage(1); // Reset à la première page
};

// Composant de pagination
const renderPagination = () => {
  const pageNumbers = [];
  const maxVisiblePages = 5;
  
  let startPage = Math.max(1, currentPage - Math.floor(maxVisiblePages / 2));
  let endPage = Math.min(totalPages, startPage + maxVisiblePages - 1);
  
  if (endPage - startPage + 1 < maxVisiblePages) {
    startPage = Math.max(1, endPage - maxVisiblePages + 1);
  }
  
  for (let i = startPage; i <= endPage; i++) {
    pageNumbers.push(i);
  }
  
  return (
    <div className="d-flex justify-content-between align-items-center flex-wrap gap-3">
      <div className="d-flex align-items-center gap-2">
        <small className="text-muted">
          Affichage de {indexOfFirstItem + 1} à {Math.min(indexOfLastItem, filteredPermissionsList.length)} sur {filteredPermissionsList.length} permissions
        </small>
        <Form.Select 
          size="sm" 
          value={itemsPerPage} 
          onChange={handleItemsPerPageChange}
          style={{ width: 'auto' }}
        >
          <option value={5}>5 par page</option>
          <option value={10}>10 par page</option>
          <option value={25}>25 par page</option>
          <option value={50}>50 par page</option>
        </Form.Select>
      </div>
      
      <nav>
        <ul className="pagination pagination-sm mb-0">
          <li className={`page-item ${currentPage === 1 ? 'disabled' : ''}`}>
            <button className="page-link" onClick={() => paginate(1)} disabled={currentPage === 1}>
              «
            </button>
          </li>
          <li className={`page-item ${currentPage === 1 ? 'disabled' : ''}`}>
            <button className="page-link" onClick={() => paginate(currentPage - 1)} disabled={currentPage === 1}>
              ‹
            </button>
          </li>
          
          {startPage > 1 && (
            <>
              <li className="page-item">
                <button className="page-link" onClick={() => paginate(1)}>1</button>
              </li>
              {startPage > 2 && <li className="page-item disabled"><span className="page-link">...</span></li>}
            </>
          )}
          
          {pageNumbers.map(number => (
            <li key={number} className={`page-item ${currentPage === number ? 'active' : ''}`}>
              <button className="page-link" onClick={() => paginate(number)}>
                {number}
              </button>
            </li>
          ))}
          
          {endPage < totalPages && (
            <>
              {endPage < totalPages - 1 && <li className="page-item disabled"><span className="page-link">...</span></li>}
              <li className="page-item">
                <button className="page-link" onClick={() => paginate(totalPages)}>{totalPages}</button>
              </li>
            </>
          )}
          
          <li className={`page-item ${currentPage === totalPages ? 'disabled' : ''}`}>
            <button className="page-link" onClick={() => paginate(currentPage + 1)} disabled={currentPage === totalPages}>
              ›
            </button>
          </li>
          <li className={`page-item ${currentPage === totalPages ? 'disabled' : ''}`}>
            <button className="page-link" onClick={() => paginate(totalPages)} disabled={currentPage === totalPages}>
              »
            </button>
          </li>
        </ul>
      </nav>
    </div>
  );
};

// Obtenir les groupes uniques des permissions
const getUniqueGroups = () => {
  const groups = new Set(permissionsList.map(p => p.group));
  return Array.from(groups).sort();
};



// Charger tous les rôles avec leurs permissions
const fetchRoles = useCallback(async () => {
  try {
    setLoading(true);
    const response = await axios.get(`${API_BASE_URL}/roles`, {
      headers: getHeaders()
    });
    
    console.log('Réponse API roles:', response.data);
    
    let rolesData = [];
    
    // Gérer les différentes structures possibles
    if (Array.isArray(response.data)) {
      rolesData = response.data;
    } else if (response.data && response.data.data && Array.isArray(response.data.data)) {
      rolesData = response.data.data;
    } else if (response.data && response.data.roles && Array.isArray(response.data.roles)) {
      rolesData = response.data.roles;
    } else {
      throw new Error('Format de données invalide');
    }
    
    // Formater les rôles avec leurs permissions
    const formattedRoles = rolesData.map(role => {
      // Récupérer les permissions du rôle
      const rolePermissions = role.permissions || [];
      
      return {
        id: role.role_id || role.id,
        role_id: role.role_id,  
        name: role.name,
        display_name: role.name ? role.name.replace(/_/g, ' ').replace(/\b\w/g, l => l.toUpperCase()) : '',
        description: role.description || `Rôle avec scope: ${role.scope || ''}`,
        scope: role.scope || '',
        is_system_role: (role.role_id && role.role_id <= 100),
        permissions_count: rolePermissions.length,
        users_count: 0,
        permissions: rolePermissions.map(perm => ({
          id: perm.permission_id || perm.id,
          name: perm.name,
          display_name: perm.name ? perm.name.replace(/:/g, ' ').replace(/\b\w/g, l => l.toUpperCase()) : '',
          description: perm.description || '',
          group: perm.name ? (perm.name.split(':')[0] || 'general') : 'general',
          action: perm.name ? (perm.name.split(':')[1] || 'access') : 'access',
          scope: role.scope || ''
        })),
        created_at: role.created_at,
        updated_at: role.updated_at
      };
    });
    
    console.log('Rôles formatés:', formattedRoles);
    setRoles(formattedRoles);
    
    // Extraire toutes les permissions uniques de tous les rôles
    const allPermissionsMap = new Map();
    
    formattedRoles.forEach(role => {
      role.permissions.forEach(perm => {
        if (!allPermissionsMap.has(perm.id)) {
          allPermissionsMap.set(perm.id, perm);
        }
      });
    });
    
    const formattedPermissions = Array.from(allPermissionsMap.values());
    console.log('Permissions uniques:', formattedPermissions);
    setPermissions(formattedPermissions);
    
    // Grouper les permissions
    const grouped = formattedPermissions.reduce((acc, perm) => {
      const group = perm.group || 'general';
      if (!acc[group]) {
        acc[group] = [];
      }
      acc[group].push(perm);
      return acc;
    }, {});
    
    setGroupedPermissions(grouped);
    
    const initialExpanded = Object.keys(grouped).reduce((acc, group) => {
      acc[group] = true;
      return acc;
    }, {});
    setExpandedGroups(initialExpanded);
    
  } catch (err) {
    // console.error('Erreur fetchRoles:', error);
   
    setError(`${err.response?.data?.message || err.message}`);
  } finally {
    setLoading(false);
  }
}, [getHeaders, showAlert]);


  // Charger toutes les permissions

  // Charger les utilisateurs pour l'assignation
  const fetchUsers = useCallback(async () => {
    try {
      console.log('Tentative de chargement des utilisateurs...');
      const response = await axios.get(`${API_BASE_URL}/users`, {
        headers: getHeaders()
      });
      
      console.log('Réponse complète:', response);
      console.log('Données reçues:', response.data);
      
      if (response.data && response.data.data && Array.isArray(response.data.data)) {
        console.log('Structure avec data.data trouvée');
        setUsers(response.data.data);
      } else if (Array.isArray(response.data)) {
        console.log('Structure en tableau trouvée');
        setUsers(response.data);
      } else if (response.data && response.data.users && Array.isArray(response.data.users)) {
        console.log('Structure avec users trouvée');
        setUsers(response.data.users);
      } else if (response.data && response.data.results && Array.isArray(response.data.results)) {
        console.log('Structure avec results trouvée');
        setUsers(response.data.results);
      } else {
        console.log('Structure non reconnue, données brutes:', response.data);
        
        if (response.data && typeof response.data === 'object') {
          const possibleArray = Object.values(response.data).find(val => Array.isArray(val));
          if (possibleArray) {
            console.log('Tableau trouvé dans les valeurs de l\'objet');
            setUsers(possibleArray);
          } else {
            setUsers([]);
            console.warn('Aucune structure de tableau trouvée dans la réponse');
          }
        } else {
          setUsers([]);
        }
      }
    } catch (error) {
      console.error('Erreur détaillée:', {
        message: error.message,
        response: error.response,
        status: error.response?.status,
        data: error.response?.data,
        config: error.config
      });
      // showAlert(`Erreur de chargement des utilisateurs: ${error.message}`, 'danger');
       setError(`${error.response?.data?.message || error.message}`);
      setUsers([]);
    }
  }, [getHeaders, showAlert]);

  // Charger les rôles d'un utilisateur spécifique
  const fetchUserRoles = useCallback(async (userId) => {
    if (!userId) return;
    
    try {
      const response = await axios.get(`${API_BASE_URL}/users/${userId}/roles`, {
        headers: getHeaders()
      });
      
      if (response.data && response.data.roles) {
        setUserRoles(response.data.roles);
      }
    } catch (err) {
      showAlert(`Erreur de chargement des rôles utilisateur: ${err.message}`, 'danger');
       setError(`${err.response?.data?.message || err.message}`);
    }
  }, [getHeaders, showAlert]);


const handleAssignPermissions = async () => {
  if (!selectedRole) {
    showAlert("Aucun rôle sélectionné", 'warning');
    return;
  }

  const validPermissions = selectedPermissions.filter(id => id && !isNaN(id));

  if (validPermissions.length === 0) {
    showAlert("Veuillez sélectionner au moins une permission valide", 'warning');
    return;
  }

  setSaving(true);

  try {
    const roleId = selectedRole.role_id || selectedRole.id;
    
    console.log('=== ASSIGNATION DES PERMISSIONS ===');
    console.log('Rôle ID:', roleId);
    console.log('Permissions à assigner (permission_ids):', validPermissions);
    
    const payload = {
      permissions: validPermissions
    };
    
    const response = await axios.post(
      `${API_BASE_URL}/roles/${roleId}/permissions`,
      payload,
      { headers: getHeaders() }
    );
    
    if (response.data) {
      showNotification(`${validPermissions.length} permission(s) assignée(s) avec succès`, 'success');
      // Fermer le modal
      setShowUserPermissionsModal(false);
      setSelectedRole(null);
      setSelectedPermissions([]);
      setPermissionsToRemove([]);
      await fetchRoles();
      await fetchAllPermissions();
    }
  } catch (error) {
    console.error('Erreur:', error);
    showAlert(`Erreur: ${error.response?.data?.message || error.message}`, 'danger');
  } finally {
    setSaving(false);
  }
};

// Récupérer les permissions d'un rôle spécifique - Version utilisant les données locales
const fetchRolePermissions = useCallback(async (roleId) => {
  if (!roleId) return;
  
  try {
    console.log(`🔍 Recherche des permissions pour le rôle ID: ${roleId}`);
    
    // Chercher le rôle dans les données déjà chargées
    const role = roles.find(r => r.id === roleId);
    
    if (role && role.permissions) {
      // Extraire les permission_id (100, 101, etc.) des permissions du rôle
      const permissionIds = role.permissions.map(p => p.permission_id || p.id);
      console.log(`📋 ${permissionIds.length} permission(s) trouvée(s) dans les données locales:`, permissionIds);
      setSelectedPermissions(permissionIds);
      return permissionIds;
    } else {
      console.log('Aucune permission trouvée pour ce rôle');
      setSelectedPermissions([]);
      return [];
    }
    
  } catch (error) {
    console.error('❌ Erreur fetchRolePermissions:', error);
    setSelectedPermissions([]);
    return [];
  }
}, [roles]);

  // Charger les détails d'un utilisateur (rôles et permissions)
  const fetchUserRolesDetails = useCallback(async (userId) => {
    if (!userId) return;
    
    setLoadingUserRoles(true);
    setSelectedUserForModal(null);
    setUserRolesDetails([]);
    
    try {
      const userResponse = await axios.get(`${API_BASE_URL}/users/${userId}`, {
        headers: getHeaders()
      });
      
      let userData = null;
      let userRoles = [];
      
      if (userResponse.data && userResponse.data.user) {
        userData = userResponse.data.user;
        userRoles = userData.roles || (userData.role ? [userData.role] : []);
      } else if (userResponse.data) {
        userData = userResponse.data;
        userRoles = userData.roles || (userData.role ? [userData.role] : []);
      }
      
      setSelectedUserForModal(userData);
      
      const formattedRoles = userRoles.map(role => ({
        id: role.role_id || role.id,
        name: role.name,
        display_name: role.name?.replace(/_/g, ' ').replace(/\b\w/g, l => l.toUpperCase()),
        description: role.description || '',
        scope: role.scope || 'local',
        assigned_at: role.created_at || null
      }));
      
      setUserRolesDetails(formattedRoles);
      
      await fetchRolesPermissions(formattedRoles);
      
    } catch (err) {
      // console.error('Erreur fetchUserRolesDetails:', error);
      // showAlert(`Erreur de chargement des rôles: ${error.message}`, 'danger');
       setError(`${err.response?.data?.message || err.message}`);
    } finally {
      setLoadingUserRoles(false);
    }
  }, [getHeaders, showAlert]);

  // Charger les permissions pour plusieurs rôles
  const fetchRolesPermissions = useCallback(async (roles) => {
    if (!roles || roles.length === 0) return;
    
    setLoadingRolePermissions(true);
    
    try {
      const permissionsMap = {};
      
      for (const role of roles) {
        try {
          const response = await axios.get(`${API_BASE_URL}/roles/${role.id}/permissions`, {
            headers: getHeaders()
          });
          
          let permissions = [];
          if (response.data && response.data.permissions) {
            permissions = response.data.permissions;
          } else if (Array.isArray(response.data)) {
            permissions = response.data;
          }
          
          permissionsMap[role.id] = permissions.map(p => ({
            id: p.permission_id || p.id,
            name: p.name,
            display_name: p.display_name || p.name?.replace(/_/g, ' ').replace(/\b\w/g, l => l.toUpperCase()),
            description: p.description || '',
            group: p.group || 'general',
            action: p.action || 'access',
            scope: p.scope || role.scope
          }));
          
        } catch (error) {
          console.error(`Erreur pour le rôle ${role.name}:`, error);
          permissionsMap[role.id] = [];
        }
      }
      
      setRolePermissionsMap(permissionsMap);
      
      const initialExpanded = roles.reduce((acc, role) => {
        acc[role.id] = true;
        return acc;
      }, {});
      setExpandedRolePermissions(initialExpanded);
      
    } catch (err) {
      // console.error('Erreur fetchRolesPermissions:', error);
      // showAlert('Erreur de chargement des permissions', 'danger');
       setError(`${err.response?.data?.message || err.message}`);
    } finally {
      setLoadingRolePermissions(false);
    }
  }, [getHeaders, showAlert]);



  const handleRetry = () => {
  setError(null);
  fetchRoles(); // Recharger les taxes
};

  // Obtenir toutes les permissions uniques de l'utilisateur
  const getUserUniquePermissions = useCallback(() => {
    const allPermissions = [];
    Object.values(rolePermissionsMap).forEach(perms => {
      perms.forEach(perm => {
        if (!allPermissions.some(p => p.id === perm.id)) {
          allPermissions.push(perm);
        }
      });
    });
    return allPermissions;
  }, [rolePermissionsMap]);

  // Grouper les permissions par catégorie
  const getGroupedUserPermissions = useCallback(() => {
    const permissions = getUserUniquePermissions();
    
    return permissions.reduce((acc, perm) => {
      const group = perm.group || 'general';
      if (!acc[group]) {
        acc[group] = [];
      }
      acc[group].push(perm);
      return acc;
    }, {});
  }, [getUserUniquePermissions]);

  // Gérer l'expansion d'un rôle
  const toggleRoleExpand = (roleId) => {
    setExpandedRolePermissions(prev => ({
      ...prev,
      [roleId]: !prev[roleId]
    }));
  };

  // Initialiser les données

// Créer un nouveau rôle
const handleCreateRole = async () => {
  if (!roleFormData.name.trim()) {
    showAlert("Le nom du rôle est requis", 'warning');
    return;
  }

  setSaving(true);

  try {
    // Utiliser le scope du user connecté
    const payload = {
      name: roleFormData.name.trim().toLowerCase().replace(/\s+/g, '_'),
      scope: userScope, // Scope du user connecté
      description: roleFormData.description.trim() || `${roleFormData.name} - Rôle ${userScope === 'global' ? 'Global' : 'Local'}`
    };

    console.log('Création rôle - Payload:', payload);
    console.log('Scope utilisé:', userScope);

    const response = await axios.post(`${API_BASE_URL}/roles`, payload, {
      headers: getHeaders()
    });

    console.log('Réponse création rôle:', response.data);

    if (response.data) {
      showNotification(`Rôle "${roleFormData.name}" créé avec succès (scope: ${userScope})`, 'success');
      setShowRoleModal(false);
      resetRoleForm();
      await fetchRoles(); // Recharger la liste des rôles
    } else {
      throw new Error('Erreur lors de la création');
    }
  } catch (error) {
    console.error('Erreur création rôle:', error);
    const errorMessage = error.response?.data?.message || error.message;
    showAlert(`Erreur lors de la création: ${errorMessage}`, 'danger');
  } finally {
    setSaving(false);
  }
};



  // Mettre à jour un rôle
  const handleUpdateRole = async () => {
    if (!editingRole || !roleFormData.name.trim()) {
      showAlert("Le nom du rôle est requis", 'warning');
      return;
    }

    setSaving(true);
console.log(editingRole.role_id);
    try {
      const response = await axios.put(
        `${API_BASE_URL}/roles/${editingRole.role_id}`,
        {
          name: roleFormData.name.toLowerCase().replace(/\s+/g, '_'),
          display_name: roleFormData.display_name || roleFormData.name,
          description: roleFormData.description,
          scope: roleFormData.scope
        },
        { headers: getHeaders() }
      );

      if (response.data) {
        showNotification('Rôle mis à jour avec succès', 'success');
        setShowRoleModal(false);
        resetRoleForm();
        fetchRoles();
      }
    } catch (error) {
      showAlert(`Erreur lors de la mise à jour: ${error.message}`, 'danger');
    } finally {
      setSaving(false);
    }
  };

  // Supprimer un rôle
  const handleDeleteRole = async () => {
    if (!selectedRole) return;

    setSaving(true);

    try {
      await axios.delete(
        `${API_BASE_URL}/roles/${selectedRole.role_id}`,
        { headers: getHeaders() }
      );

      showNotification('Rôle supprimé avec succès', 'success');
      setShowDeleteModal(false);
      setSelectedRole(null);
      fetchRoles();
    } catch (error) {
      showAlert(`Erreur lors de la suppression: ${error.message}`, 'danger');
    } finally {
      setSaving(false);
    }
  };


  // Fonction pour extraire le groupe d'une permission à partir de son nom
const getPermissionGroup = (permissionName) => {
  const groups = {
    entite: "Entités",
    tax: "Taxes",
    category: "Catégories",
    user: "Utilisateurs",
    usager: "Usagers",
    taxpayer: "Contribuables",
    reports: "Rapports",
    role_permission: "Rôles & Permissions",
    tax_collector: "Collecte de taxes"
  };
  
  const prefix = permissionName.split(':')[0];
  return groups[prefix] || prefix.charAt(0).toUpperCase() + prefix.slice(1);
};
  // Assigner des permissions à un rôle

  
// Assigner des permissions à un rôle

  // Assigner un rôle à un utilisateur
  const handleAssignUserRole = async () => {
    if (!selectedUser || !selectedUserRole) {
      showAlert("Veuillez sélectionner un utilisateur et un rôle", 'warning');
      return;
    }

    setSaving(true);

    try {
      const response = await axios.post(
        `${API_BASE_URL}/users/assign-role`,
        {
          user_id: selectedUser.toString(),
          role_id: selectedUserRole
        },
        { headers: getHeaders() }
      );

      if (response.data) {
        showNotification('Rôle assigné avec succès', 'success');
        setShowAssignModal(false);
        setSelectedUser(null);
        setSelectedUserRole(null);
        fetchUsers();
      }
    } catch (error) {
      showAlert(`Erreur lors de l'assignation: ${error.message}`, 'danger');
    } finally {
      setSaving(false);
    }
  };

  // Réinitialiser le formulaire de rôle
  const resetRoleForm = () => {
    setRoleFormData({
      name: '',
      display_name: '',
      description: '',
      scope: 'local',
      is_system_role: false
    });
    setEditingRole(null);
  };

  // Réinitialiser le formulaire de permission
  const resetPermissionForm = () => {
    setPermissionFormData({
      name: '',
      display_name: '',
      description: '',
      group: 'general',
      action: 'access'
    });
    setEditingPermission(null);
  };

  // Ouvrir le modal d'édition de rôle
  const openEditRoleModal = (role) => {
    setEditingRole(role);
    setRoleFormData({
      name: role.name,
      display_name: role.display_name || '',
      description: role.description || '',
      scope: role.scope || 'local',
      is_system_role: role.is_system_role || false
    });
    setShowRoleModal(true);
  };

const openPermissionsModal = async (role) => {
  setSelectedRole(role);
  setLoading(true);
  
  try {
    console.log('=== OUVERTURE MODAL POUR RÔLE ===');
    console.log('Rôle:', role);
    
    // Utiliser directement les données du rôle
    if (role && role.permissions) {
      // Extraire les permission_id (100, 101, etc.)
      const permissionIds = role.permissions.map(p => p.permission_id || p.id);
      console.log('Permissions assignées au rôle (permission_ids):', permissionIds);
      setSelectedPermissions(permissionIds);
    } else {
      console.log('Aucune permission trouvée pour ce rôle');
      setSelectedPermissions([]);
    }
    
    setShowUserPermissionsModal(true);
    
  } catch (error) {
    console.error('Erreur dans openPermissionsModal:', error);
    showAlert('Erreur lors du chargement des permissions', 'danger');
    setSelectedPermissions([]);
    setShowUserPermissionsModal(true);
  } finally {
    setLoading(false);
  }
};

// Synchroniser les permissions sélectionnées quand le modal s'ouvre
useEffect(() => {
  if (showUserPermissionsModal && selectedRole && !selectedUserForModal) {
    // Les permissions sont déjà chargées dans openPermissionsModal
    console.log('Modal ouvert pour le rôle:', selectedRole?.display_name);
    console.log('Permissions sélectionnées actuelles:', selectedPermissions);
  }
}, [showUserPermissionsModal, selectedRole, selectedPermissions]);


 // Gérer la sélection/déselection d'une permission - Version avec validation
const togglePermission = (permissionId) => {
  // S'assurer que l'ID est un nombre valide
  const id = typeof permissionId === 'string' ? parseInt(permissionId) : permissionId;
  
  if (isNaN(id)) {
    console.error('ID de permission invalide:', permissionId);
    return;
  }
  
  setSelectedPermissions(prev => {
    if (prev.includes(id)) {
      return prev.filter(p => p !== id);
    } else {
      return [...prev, id];
    }
  });
};



useEffect(() => {
  fetchRoles();
  fetchUsers();
  fetchAllPermissions();
  fetchDeprecatedPermissions(); // Ajoutez cette ligne
}, [fetchRoles, fetchUsers, fetchAllPermissions, fetchDeprecatedPermissions]);
  // Dans le useEffect existant, ajoutez fetchAllPermissions

  // Sélectionner/déselectionner toutes les permissions d'un groupe
  const toggleGroupPermissions = (groupPermissions, select) => {
    const groupIds = groupPermissions.map(p => p.id);
    
    setSelectedPermissions(prev => {
      if (select) {
        const newPermissions = [...prev];
        groupIds.forEach(id => {
          if (!newPermissions.includes(id)) {
            newPermissions.push(id);
          }
        });
        return newPermissions;
      } else {
        return prev.filter(id => !groupIds.includes(id));
      }
    });
  };

  // Vérifier si toutes les permissions d'un groupe sont sélectionnées
  const isGroupFullySelected = (groupPermissions) => {
    if (groupPermissions.length === 0) return false;
    return groupPermissions.every(p => selectedPermissions.includes(p.id));
  };

  // Vérifier si certaines permissions d'un groupe sont sélectionnées
  const isGroupPartiallySelected = (groupPermissions) => {
    if (groupPermissions.length === 0) return false;
    const selectedCount = groupPermissions.filter(p => selectedPermissions.includes(p.id)).length;
    return selectedCount > 0 && selectedCount < groupPermissions.length;
  };

  // Basculer l'expansion d'un groupe
  const toggleGroup = (group) => {
    setExpandedGroups(prev => ({
      ...prev,
      [group]: !prev[group]
    }));
  };

  // Filtrer les rôles
  const filteredRoles = roles.filter(role => {
    const matchesSearch = searchTerm === '' || 
      role.name.toLowerCase().includes(searchTerm.toLowerCase()) ||
      role.display_name.toLowerCase().includes(searchTerm.toLowerCase()) ||
      (role.description && role.description.toLowerCase().includes(searchTerm.toLowerCase()));
    
    const matchesScope = filterScope === 'all' || role.scope === filterScope;
    
    return matchesSearch && matchesScope;
  });




// AJOUTEZ CES LIGNES POUR LA PAGINATION DES RÔLES
const indexOfLastRole = rolesCurrentPage * rolesItemsPerPage;
const indexOfFirstRole = indexOfLastRole - rolesItemsPerPage;
const currentRoles = filteredRoles.slice(indexOfFirstRole, indexOfLastRole);
const totalRolesPages = Math.ceil(filteredRoles.length / rolesItemsPerPage);



  // Filtrer les permissions
  const filteredPermissions = permissions.filter(perm => {
    const matchesSearch = searchTerm === '' || 
      perm.name.toLowerCase().includes(searchTerm.toLowerCase()) ||
      perm.display_name.toLowerCase().includes(searchTerm.toLowerCase()) ||
      (perm.description && perm.description.toLowerCase().includes(searchTerm.toLowerCase()));
    
    const matchesGroup = filterGroup === 'all' || perm.group === filterGroup;
    
    return matchesSearch && matchesGroup;
  });



  

  // Obtenir la couleur du badge de scope
  const getScopeBadge = (scope) => {
    const colors = {
      global: "danger",
      local: "primary",
      super_admin: "dark"
    };
    
    return colors[scope] || "secondary";
  };

  // Formater le nom du groupe
  const formatGroupName = (group) => {
    const groups = {
      general: "Général",
      users: "Utilisateurs",
      roles: "Rôles",
      permissions: "Permissions",
      taxpayers: "Contribuables",
      declarations: "Déclarations",
      payments: "Paiements",
      reports: "Rapports",
      settings: "Paramètres"
    };
    
    return groups[group] || group.charAt(0).toUpperCase() + group.slice(1);
  };




const renderRolesPagination = () => {
  if (totalRolesPages <= 1) return null;
  
  const pageNumbers = [];
  const maxVisiblePages = 5;
  
  let startPage = Math.max(1, rolesCurrentPage - Math.floor(maxVisiblePages / 2));
  let endPage = Math.min(totalRolesPages, startPage + maxVisiblePages - 1);
  
  if (endPage - startPage + 1 < maxVisiblePages) {
    startPage = Math.max(1, endPage - maxVisiblePages + 1);
  }
  
  for (let i = startPage; i <= endPage; i++) {
    pageNumbers.push(i);
  }
  
  return (
    <div className="d-flex justify-content-between align-items-center flex-wrap gap-3 mt-4 pt-3 border-top">
      <div className="d-flex align-items-center gap-2">
        <small className="text-muted">
          Affichage de {indexOfFirstRole + 1} à {Math.min(indexOfLastRole, filteredRoles.length)} sur {filteredRoles.length} rôles
        </small>
        <Form.Select 
          size="sm" 
          value={rolesItemsPerPage} 
          onChange={(e) => {
            setRolesItemsPerPage(parseInt(e.target.value));
            setRolesCurrentPage(1);
          }}
          style={{ width: 'auto' }}
        >
          <option value={5}>5 par page</option>
          <option value={10}>10 par page</option>
          <option value={25}>25 par page</option>
          <option value={50}>50 par page</option>
        </Form.Select>
      </div>
      
      <nav>
        <ul className="pagination pagination-sm mb-0">
          <li className={`page-item ${rolesCurrentPage === 1 ? 'disabled' : ''}`}>
            <button className="page-link" onClick={() => setRolesCurrentPage(1)} disabled={rolesCurrentPage === 1}>
              «
            </button>
          </li>
          <li className={`page-item ${rolesCurrentPage === 1 ? 'disabled' : ''}`}>
            <button className="page-link" onClick={() => setRolesCurrentPage(rolesCurrentPage - 1)} disabled={rolesCurrentPage === 1}>
              ‹
            </button>
          </li>
          
          {startPage > 1 && (
            <>
              <li className="page-item">
                <button className="page-link" onClick={() => setRolesCurrentPage(1)}>1</button>
              </li>
              {startPage > 2 && <li className="page-item disabled"><span className="page-link">...</span></li>}
            </>
          )}
          
          {pageNumbers.map(number => (
            <li key={number} className={`page-item ${rolesCurrentPage === number ? 'active' : ''}`}>
              <button className="page-link" onClick={() => setRolesCurrentPage(number)}>
                {number}
              </button>
            </li>
          ))}
          
          {endPage < totalRolesPages && (
            <>
              {endPage < totalRolesPages - 1 && <li className="page-item disabled"><span className="page-link">...</span></li>}
              <li className="page-item">
                <button className="page-link" onClick={() => setRolesCurrentPage(totalRolesPages)}>{totalRolesPages}</button>
              </li>
            </>
          )}
          
          <li className={`page-item ${rolesCurrentPage === totalRolesPages ? 'disabled' : ''}`}>
            <button className="page-link" onClick={() => setRolesCurrentPage(rolesCurrentPage + 1)} disabled={rolesCurrentPage === totalRolesPages}>
              ›
            </button>
          </li>
          <li className={`page-item ${rolesCurrentPage === totalRolesPages ? 'disabled' : ''}`}>
            <button className="page-link" onClick={() => setRolesCurrentPage(totalRolesPages)} disabled={rolesCurrentPage === totalRolesPages}>
              »
            </button>
          </li>
        </ul>
      </nav>
    </div>
  );
};



  return (
    <React.Fragment>
      <Header />
      
      <div className="main main-app p-3 p-lg-4">
        {/* Notifications Toast */}
        <ToastContainer 
          className="p-3"
          style={{ 
            zIndex: 9999,
            position: 'fixed',
            top: '20px',
            right: '20px'
          }}
        >
          {notifications.map((notification) => (
            <Toast
              key={notification.id}
              show={notification.show}
              onClose={() => hideNotification(notification.id)}
              delay={8000}
              autohide
              className={`bg-${notification.type === 'success' ? 'success' : 
                         notification.type === 'error' ? 'danger' :
                         notification.type === 'warning' ? 'warning' : 'info'} text-white`}
            >
              <Toast.Header className={`bg-${notification.type === 'success' ? 'success' : 
                         notification.type === 'error' ? 'danger' :
                         notification.type === 'warning' ? 'warning' : 'info'} text-white`}>
                {notification.type === 'success' ? <CheckCircle className="me-2" /> :
                 notification.type === 'error' ? <XCircle className="me-2" /> :
                 notification.type === 'warning' ? <ExclamationTriangle className="me-2" /> :
                 <InfoCircle className="me-2" />}
                <strong className="me-auto">
                  {notification.type === 'success' ? 'Succès' : 
                   notification.type === 'error' ? 'Erreur' :
                   notification.type === 'warning' ? 'Attention' : 'Information'}
                </strong>
                <small>{new Date().toLocaleTimeString('fr-FR', { hour: '2-digit', minute: '2-digit' })}</small>
              </Toast.Header>
              <Toast.Body className="text-white">
                {notification.message}
              </Toast.Body>
            </Toast>
          ))}
        </ToastContainer>

        {/* Alerte */}
        {error && (
                 <Card className="border-0 shadow-sm mb-4 overflow-hidden">
                   <div className="card-gradient bg-warning" style={{ height: '4px' }}></div>
                   <Card.Body className="p-4">
                     <div className="d-flex align-items-start">
                       <div className="flex-shrink-0">
                         <div className="bg-warning bg-opacity-10 rounded-circle d-flex align-items-center justify-content-center" style={{ width: '48px', height: '48px' }}>
                           <ExclamationCircle size={24} className="text-warning" />
                         </div>
                       </div>
                       <div className="flex-grow-1 ms-3">
                         <h5 className="fw-bold mb-2 text-warning">Attention</h5>
                         <p className="mb-2 text-dark">{error}</p>
                         <div className="d-flex align-items-center mt-3 pt-1">
                           <Button 
                             variant="outline-warning" 
                             size="sm" 
                             onClick={() => setError(null)}
                             className="d-flex align-items-center gap-2 rounded-pill px-3"
                           >
                             <X size={14} />
                             <span>Fermer</span>
                           </Button>
                           <Button 
                             variant="warning" 
                             size="sm" 
                             onClick={handleRetry}
                             className="d-flex align-items-center gap-2 rounded-pill px-3 ms-2"
                           >
                             <Repeat size={14} />
                             <span>Réessayer</span>
                           </Button>
                         </div>
                       </div>
                     </div>
                   </Card.Body>
                 </Card>
               )}
      

        <div className="container-fluid">
          {/* En-tête */}
          <Row className="mb-4">
            <Col md={12}>
              <div className="d-flex justify-content-between align-items-center">
                <div>
                  <ol className="breadcrumb fs-sm mb-1">
                    <li className="breadcrumb-item"><Link to="/superAdmin/dashboard">Tableau de bord</Link></li>
                    <li className="breadcrumb-item active" aria-current="page">Gestion des droits et permissions</li>
                  </ol>
                  <div className="d-flex align-items-center">
                    <Shield className="text-primary me-2" size={28} />
                    <h4 className="main-title mb-0">Gestion des Droits et Permissions</h4>
                  </div>
                  <p className="text-muted mb-0">
                    Gérez les rôles, les permissions et les assignations aux utilisateurs
                  </p>
                </div>

                <div className="d-flex gap-2">
                  <Button
                    variant="outline-secondary"
                    onClick={() => navigate('/dashboard')}
                  >
                    <ArrowLeft className="me-2" />
                    Retour
                  </Button>
                </div>
              </div>
            </Col>
          </Row>

          {/* Barre de recherche et filtres */}
          <Row className="mb-4">
            <Col md={6}>
              <InputGroup>
                <InputGroup.Text>
                  <Search />
                </InputGroup.Text>
                <Form.Control
                  type="text"
                  placeholder="Rechercher un rôle ou une permission..."
                  value={searchTerm}
                  onChange={(e) => setSearchTerm(e.target.value)}
                />
                {searchTerm && (
                  <Button 
                    variant="outline-secondary"
                    onClick={() => setSearchTerm('')}
                  >
                    <X />
                  </Button>
                )}
              </InputGroup>
            </Col>
            <Col md={3}>
              <Form.Select
                value={filterScope}
                onChange={(e) => setFilterScope(e.target.value)}
              >
                <option value="all">Tous les scopes</option>
                <option value="local">Local</option>
                <option value="global">Global</option>
                <option value="super_admin">Super Admin</option>
              </Form.Select>
            </Col>
            <Col md={3}>
              <Form.Select
                value={filterGroup}
                onChange={(e) => setFilterGroup(e.target.value)}
              >
                <option value="all">Tous les groupes</option>
                <option value="general">Général</option>
                <option value="users">Utilisateurs</option>
                <option value="roles">Rôles</option>
                <option value="permissions">Permissions</option>
                <option value="taxpayers">Contribuables</option>
                <option value="declarations">Déclarations</option>
                <option value="payments">Paiements</option>
                <option value="reports">Rapports</option>
                <option value="settings">Paramètres</option>
              </Form.Select>
            </Col>
          </Row>

          {/* Onglets principaux */}
          <Tabs
            activeKey={activeTab}
            onSelect={(k) => setActiveTab(k)}
            className="mb-4"
          >
            
            


<Tab 
  eventKey="roles" 
  title={
    <span>
      <Shield className="me-2" />
      Gestion des Rôles ({roles.length})
    </span>
  }
>
  <Row className="g-4 mt-2">
    <Col md={12}>
      <Card className="border-0 shadow-sm">
        <Card.Header className="bg-primary text-white d-flex justify-content-between align-items-center">
          <Card.Title className="mb-0">
            <Diagram3 className="me-2" />
            Liste des rôles
          </Card.Title>
          <Button
            variant="light"
            size="sm"
            onClick={() => {
              resetRoleForm();
              setShowRoleModal(true);
            }}
          >
            <Plus className="me-2" />
            Nouveau rôle
          </Button>
        </Card.Header>
        <Card.Body>
          {/* Barre de recherche et filtres pour les rôles */}
          <div className="mb-4">
            <Row className="g-3">
              <Col md={6}>
                <InputGroup>
                  <InputGroup.Text>
                    <Search size={16} />
                  </InputGroup.Text>
                  <Form.Control
                    type="text"
                    placeholder="Rechercher un rôle par nom, description..."
                    value={searchTerm}
                    onChange={(e) => {
                      setSearchTerm(e.target.value);
                      setRolesCurrentPage(1); // Reset à la page 1 lors de la recherche
                    }}
                  />
                  {searchTerm && (
                    <Button 
                      variant="outline-secondary"
                      onClick={() => {
                        setSearchTerm('');
                        setRolesCurrentPage(1);
                      }}
                    >
                      <X size={16} />
                    </Button>
                  )}
                </InputGroup>
              </Col>
              <Col md={3}>
                <Form.Select
                  value={filterScope}
                  onChange={(e) => {
                    setFilterScope(e.target.value);
                    setRolesCurrentPage(1); // Reset à la page 1 lors du changement de filtre
                  }}
                >
                  <option value="all">Tous les scopes</option>
                  <option value="local">Local</option>
                  <option value="global">Global</option>
                  <option value="super_admin">Super Admin</option>
                </Form.Select>
              </Col>
              <Col md={3}>
                <Button 
                  variant="outline-secondary" 
                  className="w-100"
                  onClick={() => {
                    setSearchTerm('');
                    setFilterScope('all');
                    setRolesCurrentPage(1);
                  }}
                >
                  <XCircle className="me-1" size={14} />
                  Réinitialiser les filtres
                </Button>
              </Col>
            </Row>
          </div>

          {loading ? (
            <div className="text-center py-4">
              <Spinner animation="border" variant="primary" />
              <p className="mt-2">Chargement des rôles...</p>
            </div>
          ) : filteredRoles.length === 0 ? (
            <div className="text-center py-4">
              <Shield size={48} className="text-muted mb-3" />
              <h5>Aucun rôle trouvé</h5>
              <p className="text-muted">
                {searchTerm || filterScope !== 'all' 
                  ? "Aucun rôle ne correspond à vos critères de recherche" 
                  : "Commencez par créer un nouveau rôle"}
              </p>
              {!searchTerm && filterScope === 'all' && (
                <Button
                  variant="primary"
                  onClick={() => setShowRoleModal(true)}
                >
                  <Plus className="me-2" />
                  Créer un rôle
                </Button>
              )}
            </div>
          ) : (
            <>
              <Table responsive hover>
                <thead className="table-light">
                  <tr>
                    <th>Nom du rôle</th>
                    <th>Description</th>
                    <th>Scope</th>
                    <th>Permissions</th>
                    <th>Système</th>
                    <th>Actions</th>
                  </tr>
                </thead>
                <tbody>
                  {currentRoles.map((role) => (
                    <tr key={role.id}>
                      <td>
                        <div className="d-flex align-items-center">
                          <ShieldShaded className={`text-${getScopeBadge(role.scope)} me-2`} />
                          <div>
                            <strong>{role.display_name}</strong>
                            <br />
                            <small className="text-muted">{role.name}</small>
                          </div>
                        </div>
                      </td>
                      <td>
                        <small>{role.description || 'Aucune description'}</small>
                      </td>
                      <td>
                        <Badge bg={getScopeBadge(role.scope)}>
                          {role.scope === 'global' ? 'Global' : 
                           role.scope === 'super_admin' ? 'Super Admin' : 
                           'Local'}
                        </Badge>
                      </td>
                      <td>
                        <Badge bg="info">
                          {role.permissions_count || 0}
                        </Badge>
                      </td>
                      <td>
                        {role.is_system_role ? (
                          <Badge bg="dark">Système</Badge>
                        ) : (
                          <Badge bg="success">Personnalisé</Badge>
                        )}
                      </td>
                      <td>
                        <div className="d-flex gap-2">
                          <Button
                            size="sm"
                            variant="outline-primary"
                            onClick={() => openPermissionsModal(role)}
                            title="Gérer les permissions"
                          >
                            <Shield className="me-1" size={14} />
                            Permissions
                          </Button>
                          <Button
                            size="sm"
                            variant="outline-secondary"
                            onClick={() => openEditRoleModal(role)}
                            disabled={role.is_system_role}
                            title={role.is_system_role ? "Les rôles système ne peuvent pas être modifiés" : "Modifier"}
                          >
                            <Pencil size={14} />
                          </Button>
                          <Button
                            size="sm"
                            variant="outline-danger"
                            onClick={() => {
                              setSelectedRole(role);
                              setShowDeleteModal(true);
                            }}
                            disabled={role.is_system_role || role.users_count > 0}
                            title={
                              role.is_system_role ? "Les rôles système ne peuvent pas être supprimés" :
                              role.users_count > 0 ? "Ce rôle est assigné à des utilisateurs" : "Supprimer"
                            }
                          >
                            <Trash size={14} />
                          </Button>
                        </div>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </Table>
              
              {/* Pagination */}
              {renderRolesPagination()}
              
              {/* Résumé des résultats */}
              <div className="d-flex justify-content-between align-items-center mt-3 pt-2 border-top">
                <div>
                  <small className="text-muted">
                    <strong>{filteredRoles.length}</strong> rôle(s) trouvé(s)
                    {(searchTerm || filterScope !== 'all') && (
                      <span className="ms-2">
                        <Button 
                          variant="link" 
                          size="sm" 
                          className="p-0 ms-2"
                          onClick={() => {
                            setSearchTerm('');
                            setFilterScope('all');
                            setRolesCurrentPage(1);
                          }}
                        >
                          <XCircle className="me-1" size={12} />
                          Effacer les filtres
                        </Button>
                      </span>
                    )}
                  </small>
                </div>
                <div>
                  <small className="text-muted">
                    Page {rolesCurrentPage} sur {totalRolesPages || 1}
                  </small>
                </div>
              </div>
            </>
          )}
        </Card.Body>
      </Card>
    </Col>
  </Row>
</Tab>



<Tab 
  eventKey="permissions-management" 
  title={
    <span>
      <Key className="me-2" />
      Gestion des Permissions  ({filteredPermissionsList.length})
    </span>
  }
>
  <Row className="g-4 mt-2">
    <Col md={12}>
      <Card className="border-0 shadow-sm">
        <Card.Header className="bg-success text-white d-flex justify-content-between align-items-center">
          <Card.Title className="mb-0">
            <Key className="me-2" />
            Liste des permissions système
          </Card.Title>
          {user?.user_scope === 'global' && (
  <Button
    variant="light"
    size="sm"
    onClick={() => {
      resetPermissionFormModal();
      setShowCreatePermissionModal(true);
    }}
  >
    <Plus className="me-2" />
    Nouvelle permission
  </Button>
)}
        </Card.Header>
        <Card.Body>
          {/* Barre de recherche et filtres */}
          <Row className="mb-4">
            <Col md={6}>
              <InputGroup>
                <InputGroup.Text>
                  <Search />
                </InputGroup.Text>
                <Form.Control
                  type="text"
                  placeholder="Rechercher une permission..."
                  value={permissionSearchTerm}
                  onChange={(e) => {
                    setPermissionSearchTerm(e.target.value);
                    setCurrentPage(1); // Reset à la première page lors de la recherche
                  }}
                />
                {permissionSearchTerm && (
                  <Button 
                    variant="outline-secondary"
                    onClick={() => {
                      setPermissionSearchTerm('');
                      setCurrentPage(1);
                    }}
                  >
                    <X />
                  </Button>
                )}
              </InputGroup>
            </Col>
            <Col md={3}>
              <Form.Select
                value={permissionFilterGroup}
                onChange={(e) => {
                  setPermissionFilterGroup(e.target.value);
                  setCurrentPage(1); // Reset à la première page lors du changement de filtre
                }}
              >
                <option value="all">Tous les groupes</option>
                {getUniqueGroups().map(group => (
                  <option key={group} value={group}>
                    {formatGroupName(group)}
                  </option>
                ))}
              </Form.Select>
            </Col>
            <Col md={3}>
  <Form.Select
    value={permissionStatusFilter}
    onChange={(e) => {
      setPermissionStatusFilter(e.target.value);
      setCurrentPage(1);
    }}
  >
    <option value="all">Tous les statuts</option>
    <option value="active">Actif</option>
    <option value="deprecated">Déprécié</option>
    {/* <option value="inactive">Inactif</option> */}
  </Form.Select>
</Col>
          </Row>

          {loading ? (
            <div className="text-center py-4">
              <Spinner animation="border" variant="success" />
              <p className="mt-2">Chargement des permissions...</p>
            </div>
          ) : filteredPermissionsList.length === 0 ? (
            <div className="text-center py-4">
              <Key size={48} className="text-muted mb-3" />
              <h5>Aucune permission trouvée</h5>
              <p className="text-muted">
                {permissionSearchTerm ? "Aucune permission ne correspond à votre recherche" : "Commencez par créer une nouvelle permission"}
              </p>
              {!permissionSearchTerm && (
                <Button
                  variant="success"
                  onClick={() => {
                    resetPermissionFormModal();
                    setShowCreatePermissionModal(true);
                  }}
                >
                  <Plus className="me-2" />
                  Créer une permission
                </Button>
              )}
            </div>
          ) : (
            <>
              <Table responsive hover>
               
<thead className="table-light">
  <tr>
    <th>Nom</th>
    <th>Description</th>
    <th>Groupe</th>
    <th>Action</th>
    <th>Statut</th>  {/* Nouvelle colonne */}
    {user?.user_scope === 'global' && (
    <th width="150">Actions</th>
    )}
  </tr>
</thead>
<tbody>
  {currentItems.map((permission) => (
    <tr key={permission.id}>
      <td>
        <div className="d-flex flex-column">
          {/* <strong className="text-primary">{permission.name}</strong>
          <small className="text-muted">{permission.display_name}</small> */}
          Permission {permission.description || 'Aucune description'}
        </div>
      </td>
      <td><small>{permission.description || 'Aucune description'}</small></td>
      <td><Badge bg="info">{formatGroupName(permission.group)}</Badge></td>
      <td><Badge bg="warning" text="dark">{permission.action}</Badge></td>
      {/* Badge de statut */}
      <td>
        <Badge 
          bg={permission.status === 'active' ? 'success' : permission.status === 'deprecated' ? 'warning' : 'secondary'}
          className="px-2 py-1"
        >
          {permission.status === 'active' ? 'Actif' : permission.status === 'deprecated' ? 'Déprécié' : 'Inactif'}
        </Badge>
      </td>
      {user?.user_scope === 'global' && (
      <td>
         
        <div className="d-flex gap-2">

          <Button
            size="sm"
            variant="outline-primary"
            onClick={() => openEditPermissionModal(permission)}
            title="Modifier"
          >
            <Pencil size={14} />
          </Button>
          {/* <Button
            size="sm"
            variant="outline-danger"
            onClick={() => {
              setSelectedPermissionItem(permission);
              setShowDeletePermissionModal(true);
            }}
            title="Supprimer"
            disabled={permission.status === 'deprecated'}
          >
            <Trash size={14} />
          </Button> */}
        </div>
        
      </td>
      )}
      </tr>
 
  ))}
</tbody>
              </Table>
              
              {/* Pagination */}
              {totalPages > 1 && renderPagination()}
            </>
          )}

          {/* Statistiques */}
          {permissionsList.length > 0 && (
            <div className="mt-4 pt-3 border-top">
              <Row>
                <Col md={6}>
                  <div className="text-center">
                    <h5>{permissionsList.length}</h5>
                    <small className="text-muted">Total permissions</small>
                  </div>
                </Col>
                <Col md={6}>
                  <div className="text-center">
                    <h5>{getUniqueGroups().length}</h5>
                    <small className="text-muted">Groupes</small>
                  </div>
                </Col>
              </Row>
            </div>
          )}
        </Card.Body>
      </Card>
    </Col>
  </Row>
</Tab>





<Tab 
  eventKey="permissions-deprecated" 
  title={
    <span>
      <ExclamationTriangle className="me-2" />
      Permissions Dépréciées ({deprecatedPermissionsList.length})
    </span>
  }
>
  <Row className="g-4 mt-2">
    <Col md={12}>
      <Card className="border-0 shadow-sm">
        <Card.Header className="bg-warning text-white d-flex justify-content-between align-items-center">
          <Card.Title className="mb-0">
            <ExclamationTriangle className="me-2" />
            Permissions dépréciées (Deprecated)
          </Card.Title>
          <small className="text-white-50">
            Ces permissions sont en cours de remplacement
          </small>
        </Card.Header>
        <Card.Body>
          {loading ? (
            <div className="text-center py-4">
              <Spinner animation="border" variant="warning" />
              <p className="mt-2">Chargement des permissions dépréciées...</p>
            </div>
          ) : deprecatedPermissionsList.length === 0 ? (
            <div className="text-center py-4">
              <CheckCircle size={48} className="text-success mb-3" />
              <h5>Aucune permission dépréciée</h5>
              <p className="text-muted">
                Toutes les permissions sont actuellement actives.
              </p>
            </div>
          ) : (
            <>
              <div className="alert alert-warning mb-3">
                <ExclamationTriangle className="me-2" />
                <strong>Attention:</strong> Ces permissions sont dépréciées et seront supprimées dans une future version. 
                Veuillez migrer vers les nouvelles permissions équivalentes.
              </div>
              
              {/* Tableau des permissions dépréciées */}
              <div className="table-responsive">
                <Table responsive hover>
                  <thead className="table-light">
                    <tr>
                      <th>Nom</th>
                      <th>Description</th>
                      <th>Groupe</th>
                      <th>Action</th>
                      <th>Statut</th>
                      {user?.user_scope === 'global' && (
                      <th width="150">Actions</th>
                      )}
                    </tr>
                  </thead>
                  <tbody>
                    {deprecatedPermissionsList.map((permission) => (
                      <tr key={permission.id} className="table-warning">
                        <td>
                          <div className="d-flex flex-column">
                            {/* <strong className="text-warning">{permission.name}</strong>
                            <small className="text-muted">{permission.display_name}</small> */}
                            Permission {permission.description || 'Aucune description'}
                          </div>
                        </td>
                        <td><small>{permission.description || 'Aucune description'}</small></td>
                        <td><Badge bg="info">{formatGroupName(permission.group)}</Badge></td>
                        <td><Badge bg="warning" text="dark">{permission.action}</Badge></td>
                        <td>
                          <Badge bg="warning" className="px-2 py-1">
                            <ExclamationTriangle className="me-1" size={12} />
                            Déprécié
                          </Badge>
                        </td>
                        {user?.user_scope === 'global' && (
                        <td>
                          <div className="d-flex gap-2">
                            <Button
                              size="sm"
                              variant="outline-warning"
                              onClick={() => openEditPermissionModal(permission)}
                              title="Modifier le statut"
                            >
                              <Pencil size={14} />
                            </Button>




                            <Button
            size="sm"
            variant="outline-danger"
            onClick={() => {
              setSelectedPermissionItem(permission);
              setShowDeletePermissionModal(true);
            }}
            title="Supprimer"
            
          >
            <Trash size={14} />
          </Button> 
                          </div>
                        </td>
                        )}
                      </tr>
                    ))}
                  </tbody>
                </Table>
              </div>
              
              {/* Statistiques des permissions dépréciées */}
              <div className="mt-4 pt-3 border-top">
                <Row>
                  <Col md={6}>
                    <div className="text-center">
                      <h5 className="text-warning">{deprecatedPermissionsList.length}</h5>
                      <small className="text-muted">Permissions dépréciées</small>
                    </div>
                  </Col>
                  <Col md={6}>
                    <div className="text-center">
                      <Button 
                        variant="outline-warning" 
                        size="sm"
                        onClick={() => {
                          const csvData = deprecatedPermissionsList.map(p => ({
                            Permission: p.name,
                            Description: p.description,
                            Groupe: p.group,
                            Action: p.action
                          }));
                          const headers = Object.keys(csvData[0]).join(',');
                          const rows = csvData.map(item => Object.values(item).map(v => `"${v}"`).join(','));
                          const blob = new Blob([headers, ...rows].join('\n'), { type: 'text/csv' });
                          const link = document.createElement('a');
                          link.href = URL.createObjectURL(blob);
                          link.download = `permissions_deprecated_${new Date().toISOString().split('T')[0]}.csv`;
                          link.click();
                          URL.revokeObjectURL(link.href);
                          showNotification('Export CSV réussi', 'success');
                        }}
                      >
                        <Download className="me-2" />
                        Exporter la liste
                      </Button>
                    </div>
                  </Col>
                </Row>
              </div>
            </>
          )}
        </Card.Body>
      </Card>
    </Col>
  </Row>
</Tab>




           <Tab 
  eventKey="roles-permissions" 
  title={
    <span>
      <Diagram3 className="me-2" />
      Rôles x Permissions
    </span>
  }
>
  <Row className="g-4 mt-2">
    <Col md={12}>
      <Card className="border-0 shadow-sm">
        <Card.Header className="bg-info text-white">
          <Card.Title className="mb-0">
            <Shield className="me-2" />
            Matrice des permissions par rôle
          </Card.Title>
        </Card.Header>
        <Card.Body>
          {loading ? (
            <div className="text-center py-4">
              <Spinner animation="border" variant="info" />
              <p className="mt-2">Chargement de la matrice des permissions...</p>
            </div>
          ) : roles.length === 0 ? (
            <div className="text-center py-4">
              <Shield size={48} className="text-muted mb-3" />
              <h5>Aucun rôle disponible</h5>
              <p className="text-muted">
                Commencez par créer des rôles pour voir la matrice des permissions.
              </p>
            </div>
          ) : (
            <div>
              {/* Légende */}
              <div className="mb-3 d-flex gap-3 align-items-center">
                <span className="text-muted">Légende:</span>
                <Badge bg="success" className="px-3 py-2">
                  <CheckCircle className="me-1" size={12} />
                  Permission accordée
                </Badge>
                <Badge bg="light" text="dark" className="px-3 py-2 border">
                  <XCircle className="me-1" size={12} />
                  Permission non accordée
                </Badge>
              </div>

              {/* Tableau matriciel */}
              <div className="table-responsive">
                <Table bordered hover className="matrix-table">
                  <thead>
                    <tr>
                      <th style={{ minWidth: '250px', backgroundColor: '#f8f9fa' }}>
                        <div className="d-flex align-items-center">
                          <Key className="me-2 text-warning" />
                          Permissions
                        </div>
                      </th>
                      {roles.map(role => (
                        <th key={role.id} className="text-center" style={{ minWidth: '150px', backgroundColor: '#f8f9fa' }}>
                          <div className="d-flex flex-column align-items-center">
                            <ShieldShaded className={`text-${getScopeBadge(role.scope)} mb-1`} size={20} />
                            <span className="fw-bold">{role.display_name}</span>
                            <Badge bg={getScopeBadge(role.scope)} className="mt-1">
                              {role.scope}
                            </Badge>
                          </div>
                        </th>
                      ))}
                    </tr>
                  </thead>
                  <tbody>
                    {/* Parcourir toutes les permissions groupées */}
                    {Object.entries(groupedPermissions).map(([group, perms]) => (
                      <React.Fragment key={group}>
                        {/* Ligne d'en-tête du groupe */}
                        <tr className="table-secondary">
                          <td colSpan={roles.length + 1}>
                            <strong className="text-primary">
                              {formatGroupName(group)} ({perms.length})
                            </strong>
                          </td>
                        </tr>
                        
                        {/* Lignes des permissions du groupe */}
                        {perms.map(permission => (
                          <tr key={permission.id}>
                            <td>
                              <div className="d-flex flex-column">
                                <span className="fw-medium">{permission.display_name}</span>
                                <small className="text-muted">{permission.description || permission.name}</small>
                                <div className="mt-1">
                                  <Badge bg="info" className="me-1" style={{ fontSize: '0.7rem' }}>
                                    {permission.action}
                                  </Badge>
                                  <Badge bg={getScopeBadge(permission.scope)} style={{ fontSize: '0.7rem' }}>
                                    {permission.scope}
                                  </Badge>
                                </div>
                              </div>
                            </td>
                            
                            {/* Pour chaque rôle, vérifier si la permission est assignée */}
                            {roles.map(role => {
                              // Vérifier si le rôle a cette permission
                              const hasPermission = role.permissions?.some(
                                p => (p.permission_id || p.id) === permission.id
                              );
                              
                              return (
                                <td key={`${role.id}-${permission.id}`} className="text-center align-middle">
                                  {hasPermission ? (
                                    <div className="d-flex justify-content-center">
                                      <Badge bg="success" className="p-2" style={{ borderRadius: '50%' }}>
                                        <CheckCircle size={16} />
                                      </Badge>
                                    </div>
                                  ) : (
                                    <div className="d-flex justify-content-center">
                                      <Badge bg="light" text="secondary" className="p-2 border" style={{ borderRadius: '50%' }}>
                                        <XCircle size={16} />
                                      </Badge>
                                    </div>
                                  )}
                                </td>
                              );
                            })}
                          </tr>
                        ))}
                      </React.Fragment>
                    ))}
                  </tbody>
                </Table>
              </div>

              {/* Résumé statistique */}
              <Card className="mt-4 bg-light">
                <Card.Body>
                  <Row>
                    <Col md={3}>
                      <div className="text-center">
                        <h5>{roles.length}</h5>
                        <small className="text-muted">Rôles</small>
                      </div>
                    </Col>
                    <Col md={3}>
                      <div className="text-center">
                        <h5>{permissions.length}</h5>
                        <small className="text-muted">Permissions</small>
                      </div>
                    </Col>
                    <Col md={3}>
                      <div className="text-center">
                        <h5>
                          {roles.reduce((acc, role) => 
                            acc + (role.permissions?.length || 0), 0
                          )}
                        </h5>
                        <small className="text-muted">Assignations totales</small>
                      </div>
                    </Col>
                    <Col md={3}>
                      <div className="text-center">
                        <h5>
                          {roles.length > 0 
                            ? Math.round(
                                (roles.reduce((acc, role) => 
                                  acc + (role.permissions?.length || 0), 0
                                ) / (roles.length * permissions.length)) * 100
                              ) 
                            : 0}%
                        </h5>
                        <small className="text-muted">Taux de couverture</small>
                      </div>
                    </Col>
                  </Row>
                </Card.Body>
              </Card>
            </div>
          )}
        </Card.Body>
      </Card>
    </Col>
  </Row>
</Tab>
          </Tabs>
        </div>

        {/* Modal de création/édition de rôle */}
      <Modal show={showRoleModal} onHide={() => { setShowRoleModal(false); resetRoleForm(); }} size="lg" centered>
  <Modal.Header closeButton className="bg-primary text-white">
    <Modal.Title>
      <Shield className="me-2" />
      {editingRole ? 'Modifier le rôle' : 'Créer un nouveau rôle'}
    </Modal.Title>
  </Modal.Header>
  <Modal.Body>
    <Form>
      <Row>
        <Col md={12}>
          <Form.Group className="mb-3">
            <Form.Label>Nom du rôle <span className="text-danger">*</span></Form.Label>
            <Form.Control
              type="text"
              value={roleFormData.name}
              onChange={(e) => setRoleFormData({...roleFormData, name: e.target.value})}
              placeholder="ex: super_admin, gestionnaire, etc."
              disabled={editingRole?.is_system_role}
            />
            <Form.Text className="text-muted">
              Utilisez des minuscules et des underscores
            </Form.Text>
          </Form.Group>
        </Col>
      </Row>
      
      <Form.Group className="mb-3">
        <Form.Label>Description</Form.Label>
        <Form.Control
          as="textarea"
          rows={3}
          value={roleFormData.description}
          onChange={(e) => setRoleFormData({...roleFormData, description: e.target.value})}
          placeholder="Description du rôle et de ses responsabilités..."
        />
      </Form.Group>
      
      <Form.Group className="mb-3">
        <Form.Label>Scope</Form.Label>
        <Form.Control
          type="text"
          value={userScope === 'global' ? 'Global' : userScope === 'super_admin' ? 'Super Admin' : 'Local'}
          disabled
          className="bg-light"
        />
        <Form.Text className="text-muted">
          <InfoCircle className="me-1" size={12} />
          Scope basé sur votre niveau d'accès: <strong className="text-primary">
            {userScope === 'global' ? 'Accès global (toutes les entités)' : 
             userScope === 'super_admin' ? 'Accès Super Administrateur' : 
             'Accès local (entité uniquement)'}
          </strong>
        </Form.Text>
      </Form.Group>
      
      {/* Message d'information supplémentaire */}
      <Alert variant="info" className="mt-3">
        <InfoCircle className="me-2" />
        <small>
          Le scope est automatiquement défini selon votre profil. 
          Les rôles créés auront le scope: <strong>{userScope === 'global' ? 'Global' : userScope === 'super_admin' ? 'Super Admin' : 'Local'}</strong>
        </small>
      </Alert>
    </Form>
  </Modal.Body>
  <Modal.Footer>
    <Button variant="secondary" onClick={() => { setShowRoleModal(false); resetRoleForm(); }}>
      <X className="me-2" />
      Annuler
    </Button>
    <Button 
      variant="primary" 
      onClick={editingRole ? handleUpdateRole : handleCreateRole}
      disabled={saving || !roleFormData.name.trim()}
    >
      {saving ? (
        <>
          <Spinner animation="border" size="sm" className="me-2" />
          {editingRole ? 'Mise à jour...' : 'Création...'}
        </>
      ) : (
        <>
          <Save className="me-2" />
          {editingRole ? 'Mettre à jour' : 'Créer le rôle'}
        </>
      )}
    </Button>
  </Modal.Footer>
</Modal>








{/* Modal de création de permission */}
<Modal 
  show={showCreatePermissionModal} 
  onHide={() => {
    setShowCreatePermissionModal(false);
    resetPermissionFormModal();
  }} 
  centered
>
  <Modal.Header closeButton className="bg-success text-white">
    <Modal.Title>
      <Plus className="me-2" />
      Créer une nouvelle permission
    </Modal.Title>
  </Modal.Header>
  <Modal.Body>
    <Form>
      <Form.Group className="mb-3">
        <Form.Label>
          Nom de la permission <span className="text-danger">*</span>
        </Form.Label>
        <Form.Control
          type="text"
          value={permissionForm.name}
          onChange={(e) => setPermissionForm({...permissionForm, name: e.target.value})}
          placeholder="ex: usagers.update, taxes.create, etc."
        />
        <Form.Text className="text-muted">
          Format: "resource.action" (ex: users.create, roles.update, permissions.delete)
        </Form.Text>
      </Form.Group>
      
      <Form.Group className="mb-3">
        <Form.Label>Description</Form.Label>
        <Form.Control
          as="textarea"
          rows={3}
          value={permissionForm.description}
          onChange={(e) => setPermissionForm({...permissionForm, description: e.target.value})}
          placeholder="Description détaillée de la permission..."
        />
      </Form.Group>
    </Form>
  </Modal.Body>
  <Modal.Footer>
    <Button 
      variant="secondary" 
      onClick={() => {
        setShowCreatePermissionModal(false);
        resetPermissionFormModal();
      }}
    >
      Annuler
    </Button>
    <Button 
      variant="success" 
      onClick={handleCreatePermission}
      disabled={savingPermission || !permissionForm.name.trim()}
    >
      {savingPermission ? (
        <>
          <Spinner animation="border" size="sm" className="me-2" />
          Création...
        </>
      ) : (
        <>
          <Save className="me-2" />
          Créer la permission
        </>
      )}
    </Button>
  </Modal.Footer>
</Modal>

{/* Modal d'édition de permission */}
<Modal 
  show={showEditPermissionModal} 
  onHide={() => {
    setShowEditPermissionModal(false);
    resetPermissionFormModal();
  }} 
  centered
>
  <Modal.Header closeButton className="bg-warning text-white">
    <Modal.Title>
      <Pencil className="me-2" />
      Modifier la permission
    </Modal.Title>
  </Modal.Header>
  <Modal.Body>
    <Form>
      <Form.Group className="mb-3">
        <Form.Label>
          Nom de la permission <span className="text-danger">*</span>
        </Form.Label>
        <Form.Control
          type="text"
          value={permissionForm.name}
          onChange={(e) => setPermissionForm({...permissionForm, name: e.target.value})}
          placeholder="ex: usagers.update, taxes.create, etc."
        />
        <Form.Text className="text-muted">
          Format: "resource.action" (ex: users.create, roles.update, permissions.delete)
        </Form.Text>
      </Form.Group>
      
      <Form.Group className="mb-3">
        <Form.Label>Description</Form.Label>
        <Form.Control
          as="textarea"
          rows={3}
          value={permissionForm.description}
          onChange={(e) => setPermissionForm({...permissionForm, description: e.target.value})}
          placeholder="Description détaillée de la permission..."
        />
      </Form.Group>
      
      {/* Nouveau champ pour le statut */}
      <Form.Group className="mb-3">
        <Form.Label>Statut</Form.Label>
        <Form.Select
          value={permissionForm.status}
          onChange={(e) => setPermissionForm({...permissionForm, status: e.target.value})}
        >
          <option value="active">Actif</option>
          <option value="deprecated">Déprécié (Deprecated)</option>
          {/* <option value="inactive">Inactif</option> */}
        </Form.Select>
        <Form.Text className="text-muted">
          <InfoCircle className="me-1" size={12} />
          <strong>Actif:</strong> Permission utilisable<br />
          <strong>Déprécié:</strong> Permission en cours de remplacement<br />
          {/* <strong>Inactif:</strong> Permission désactivée */}
        </Form.Text>
      </Form.Group>
      
      {/* Afficher le statut actuel avec badge */}
      <Alert variant={permissionForm.status === 'active' ? 'success' : permissionForm.status === 'deprecated' ? 'warning' : 'secondary'} className="mt-2">
        <InfoCircle className="me-2" />
        Statut actuel: <strong>{permissionForm.status === 'active' ? 'Actif' : permissionForm.status === 'deprecated' ? 'Déprécié' : 'Inactif'}</strong>
      </Alert>
    </Form>
  </Modal.Body>
  <Modal.Footer>
    <Button 
      variant="secondary" 
      onClick={() => {
        setShowEditPermissionModal(false);
        resetPermissionFormModal();
      }}
    >
      Annuler
    </Button>
    <Button 
      variant="warning" 
      onClick={handleUpdatePermission}
      disabled={savingPermission || !permissionForm.name.trim()}
    >
      {savingPermission ? (
        <>
          <Spinner animation="border" size="sm" className="me-2" />
          Mise à jour...
        </>
      ) : (
        <>
          <Save className="me-2" />
          Mettre à jour
        </>
      )}
    </Button>
  </Modal.Footer>
</Modal>



{/* Modal de confirmation de suppression de permission */}
<Modal 
  show={showDeletePermissionModal} 
  onHide={() => {
    setShowDeletePermissionModal(false);
    setSelectedPermissionItem(null);
  }} 
  centered
>
  <Modal.Header closeButton className="bg-danger text-white">
    <Modal.Title>
      <Trash className="me-2" />
      Confirmer la suppression
    </Modal.Title>
  </Modal.Header>
  <Modal.Body>
    <div className="text-center">
      <ExclamationTriangle size={48} className="text-danger mb-3" />
      <h5>Êtes-vous sûr de vouloir supprimer cette permission ?</h5>
      {selectedPermissionItem && (
        <div className="mt-3 p-3 bg-light rounded">
          <strong>{selectedPermissionItem.name}</strong>
          <br />
          <small className="text-muted">{selectedPermissionItem.description || 'Aucune description'}</small>
        </div>
      )}
      <p className="text-muted mt-3">
        <strong className="text-danger">Attention:</strong> Cette action est irréversible. 
        Les rôles qui utilisent cette permission perdront cette fonctionnalité.
      </p>
    </div>
  </Modal.Body>
  <Modal.Footer>
    <Button variant="secondary" onClick={() => {
      setShowDeletePermissionModal(false);
      setSelectedPermissionItem(null);
    }}>
      Annuler
    </Button>
    <Button 
      variant="danger" 
      onClick={handleDeletePermission}
      disabled={savingPermission}
    >
      {savingPermission ? (
        <>
          <Spinner animation="border" size="sm" className="me-2" />
          Suppression...
        </>
      ) : (
        <>
          <Trash className="me-2" />
          Supprimer définitivement
        </>
      )}
    </Button>
  </Modal.Footer>
</Modal>





{/* Modal de gestion des permissions du rôle - Version avec boutons dans le footer */}
<Modal 
  show={showUserPermissionsModal && !selectedUserForModal} 
  onHide={() => {
    setShowUserPermissionsModal(false);
    setSelectedRole(null);
    setSelectedPermissions([]);
    setPermissionsToRemove([]);
    setPermissionSearchKeyword('');
    setPermissionCurrentPage(1);
  }} 
  size="xl" 
  centered
>
  <Modal.Header closeButton className="bg-info text-white">
    <Modal.Title>
      <Shield className="me-2" />
      Gérer les permissions - {selectedRole?.display_name}
    </Modal.Title>
  </Modal.Header>
  <Modal.Body style={{ maxHeight: '70vh', overflowY: 'auto' }}>
    {loading ? (
      <div className="text-center py-4">
        <Spinner animation="border" variant="info" />
        <p className="mt-2">Chargement des permissions...</p>
      </div>
    ) : (
      <div>
        <Alert variant="info" className="mb-2">
          <InfoCircle className="me-2" />
          Gérez les permissions du rôle <strong>{selectedRole?.display_name}</strong>
        </Alert>
        
        {/* Onglets pour Assigner / Retirer */}
        <Tabs defaultActiveKey="assign" className="mb-3" id="permissions-tabs">
          
          {/* Tab Assigner des permissions */}
          <Tab eventKey="assign" title="Assigner des permissions">
            {/* Barre de recherche et actions */}
            <div className="d-flex justify-content-between align-items-center mb-3 flex-wrap gap-2">
              <div className="d-flex gap-2">
                <Button
                  variant="outline-primary"
                  size="sm"
                  onClick={() => {
                    const allPermissionIds = permissionsList
                      .filter(p => !selectedPermissions.includes(p.permission_id || p.id))
                      .map(p => p.permission_id || p.id)
                      .filter(id => id !== null);
                    setSelectedPermissions(prev => [...new Set([...prev, ...allPermissionIds])]);
                  }}
                >
                  <CheckCircle className="me-1" size={14} />
                  Tout sélectionner
                </Button>
                <Button
                  variant="outline-secondary"
                  size="sm"
                  onClick={() => setSelectedPermissions([])}
                >
                  <XCircle className="me-1" size={14} />
                  Tout désélectionner
                </Button>
              </div>
              
              <div className="d-flex gap-2">
                <InputGroup style={{ width: '250px' }}>
                  <InputGroup.Text><Search size={14} /></InputGroup.Text>
                  <Form.Control
                    type="text"
                    placeholder="Rechercher une permission..."
                    value={permissionSearchKeyword}
                    onChange={(e) => {
                      setPermissionSearchKeyword(e.target.value);
                      setPermissionCurrentPage(1);
                    }}
                    size="sm"
                  />
                  {permissionSearchKeyword && (
                    <Button variant="outline-secondary" size="sm" onClick={() => { setPermissionSearchKeyword(''); setPermissionCurrentPage(1); }}>
                      <X size={14} />
                    </Button>
                  )}
                </InputGroup>
                
                <Form.Select size="sm" value={permissionItemsPerPage} onChange={changePermissionItemsPerPage} style={{ width: 'auto' }}>
                  <option value={5}>5 par page</option>
                  <option value={10}>10 par page</option>
                  <option value={25}>25 par page</option>
                  <option value={50}>50 par page</option>
                </Form.Select>
              </div>
            </div>
            
            {/* Tableau des permissions disponibles */}
            {permissionsList.length === 0 ? (
              <div className="text-center py-4">
                <Key size={48} className="text-muted mb-3" />
                <p>Aucune permission disponible dans le système.</p>
              </div>
            ) : (
              <>
                <div className="table-responsive">
                  <Table hover className="table-sm">
                    <thead className="table-light">
                      <tr>
                        <th style={{ width: '40px' }}>
                          <Form.Check
                            type="checkbox"
                            checked={getPaginatedPermissions().items.length > 0 && 
                              getPaginatedPermissions().items.every(p => {
                                const id = p.permission_id || p.id;
                                return selectedPermissions.includes(id);
                              })}
                            indeterminate={getPaginatedPermissions().items.some(p => {
                              const id = p.permission_id || p.id;
                              return selectedPermissions.includes(id);
                            }) && 
                              !getPaginatedPermissions().items.every(p => {
                                const id = p.permission_id || p.id;
                                return selectedPermissions.includes(id);
                              })}
                            onChange={(e) => {
                              const currentPageIds = getPaginatedPermissions().items
                                .map(p => p.permission_id || p.id)
                                .filter(id => id !== null);
                              
                              if (e.target.checked) {
                                setSelectedPermissions(prev => [...new Set([...prev, ...currentPageIds])]);
                              } else {
                                setSelectedPermissions(prev => prev.filter(id => !currentPageIds.includes(id)));
                              }
                            }}
                          />
                        </th>
                        <th>Permission</th>
                        <th>Description</th>
                        <th>Groupe</th>
                        <th>Action</th>
                      </tr>
                    </thead>
                    <tbody>
                      {getPaginatedPermissions().items.map((permission) => {
                        const permId = permission.permission_id || permission.id;
                        const isAssigned = selectedPermissions.includes(permId);
                        
                        return (
                          <tr key={permission.id} className={isAssigned ? 'table-success' : ''}>
                            <td>
                              <Form.Check
                                type="checkbox"
                                checked={isAssigned}
                                onChange={() => togglePermission(permId)}
                              />
                            </td>
                            <td>
                              <div className="d-flex flex-column">
                                Permission {permission.description || 'Aucune description'}
                                {/* <strong className="text-primary">{permission.name}</strong> */}
                                <small className="text-muted">{permission.display_name}</small>
                                <small className="text-muted">ID: {permId}</small>
                              </div>
                            </td>
                            <td><small>{permission.description || 'Aucune description'}</small></td>
                            <td><Badge bg="info">{formatGroupName(permission.group)}</Badge></td>
                            <td><Badge bg="warning" text="dark">{permission.action}</Badge></td>
                          </tr>
                        );
                      })}
                    </tbody>
                  </Table>
                </div>
                
                {/* Pagination */}
                {getPaginatedPermissions().totalPages > 1 && (
                  <div className="d-flex justify-content-between align-items-center mt-3 flex-wrap gap-2">
                    <small className="text-muted">
                      Affichage de {((permissionCurrentPage - 1) * permissionItemsPerPage) + 1} à{' '}
                      {Math.min(permissionCurrentPage * permissionItemsPerPage, getPaginatedPermissions().total)} sur{' '}
                      {getPaginatedPermissions().total} permissions
                    </small>
                    
                    <nav>
                      <ul className="pagination pagination-sm mb-0">
                        <li className={`page-item ${permissionCurrentPage === 1 ? 'disabled' : ''}`}>
                          <button className="page-link" onClick={() => changePermissionPage(1)} disabled={permissionCurrentPage === 1}>«</button>
                        </li>
                        <li className={`page-item ${permissionCurrentPage === 1 ? 'disabled' : ''}`}>
                          <button className="page-link" onClick={() => changePermissionPage(permissionCurrentPage - 1)} disabled={permissionCurrentPage === 1}>‹</button>
                        </li>
                        
                        {(() => {
                          const totalPages = getPaginatedPermissions().totalPages;
                          const currentPage = permissionCurrentPage;
                          const maxVisible = 5;
                          let startPage = Math.max(1, currentPage - Math.floor(maxVisible / 2));
                          let endPage = Math.min(totalPages, startPage + maxVisible - 1);
                          
                          if (endPage - startPage + 1 < maxVisible) {
                            startPage = Math.max(1, endPage - maxVisible + 1);
                          }
                          
                          const pages = [];
                          for (let i = startPage; i <= endPage; i++) {
                            pages.push(i);
                          }
                          
                          return pages.map(number => (
                            <li key={number} className={`page-item ${permissionCurrentPage === number ? 'active' : ''}`}>
                              <button className="page-link" onClick={() => changePermissionPage(number)}>{number}</button>
                            </li>
                          ));
                        })()}
                        
                        <li className={`page-item ${permissionCurrentPage === getPaginatedPermissions().totalPages ? 'disabled' : ''}`}>
                          <button className="page-link" onClick={() => changePermissionPage(permissionCurrentPage + 1)} disabled={permissionCurrentPage === getPaginatedPermissions().totalPages}>›</button>
                        </li>
                        <li className={`page-item ${permissionCurrentPage === getPaginatedPermissions().totalPages ? 'disabled' : ''}`}>
                          <button className="page-link" onClick={() => changePermissionPage(getPaginatedPermissions().totalPages)} disabled={permissionCurrentPage === getPaginatedPermissions().totalPages}>»</button>
                        </li>
                      </ul>
                    </nav>
                  </div>
                )}
                
                {/* Bouton d'assignation dans le footer du tab */}
                <div className="mt-3 pt-2 border-top d-flex justify-content-end">
                  <Button
                    variant="primary"
                    onClick={handleAssignPermissions}
                    disabled={saving || selectedPermissions.length === 0}
                  >
                    {saving ? (
                      <><Spinner animation="border" size="sm" className="me-2" />Assignation en cours...</>
                    ) : (
                      <><Plus className="me-2" size={14} />Assigner {selectedPermissions.length} permission(s)</>
                    )}
                  </Button>
                </div>
              </>
            )}
          </Tab>
          
          {/* Tab Retirer des permissions */}
          <Tab eventKey="remove" title="Retirer des permissions">
            <div className="mb-3">
              <Alert variant="warning" className="mb-3">
                <ExclamationTriangle className="me-2" />
                <strong>Attention:</strong> Le retrait d'une permission peut affecter les fonctionnalités du rôle.
              </Alert>
              
              <div className="d-flex justify-content-between align-items-center mb-3 flex-wrap gap-2">
                <div className="d-flex gap-2">
                  <Button
                    variant="outline-danger"
                    size="sm"
                    onClick={() => {
                      const allAssignedIds = [...selectedPermissions];
                      setPermissionsToRemove(allAssignedIds);
                    }}
                  >
                    <CheckCircle className="me-1" size={14} />
                    Tout sélectionner
                  </Button>
                  <Button
                    variant="outline-secondary"
                    size="sm"
                    onClick={() => setPermissionsToRemove([])}
                  >
                    <XCircle className="me-1" size={14} />
                    Tout désélectionner
                  </Button>
                </div>
              </div>
              
              {selectedPermissions.length === 0 ? (
                <div className="text-center py-4">
                  <Shield size={48} className="text-muted mb-3" />
                  <h5>Aucune permission assignée</h5>
                  <p className="text-muted">Ce rôle n'a aucune permission à retirer.</p>
                </div>
              ) : (
                <>
                  <div className="table-responsive">
                    <Table hover className="table-sm">
                      <thead className="table-light">
                        <tr>
                          <th style={{ width: '40px' }}>
                            <Form.Check
                              type="checkbox"
                              checked={permissionsToRemove.length === selectedPermissions.length && selectedPermissions.length > 0}
                              indeterminate={permissionsToRemove.length > 0 && permissionsToRemove.length < selectedPermissions.length}
                              onChange={(e) => {
                                if (e.target.checked) {
                                  setPermissionsToRemove([...selectedPermissions]);
                                } else {
                                  setPermissionsToRemove([]);
                                }
                              }}
                            />
                          </th>
                          <th>Permission</th>
                          <th>Description</th>
                          <th>Groupe</th>
                          <th>Action</th>
                        </tr>
                      </thead>
                      <tbody>
                        {permissionsList
                          .filter(p => selectedPermissions.includes(p.permission_id || p.id))
                          .map((permission) => {
                            const permId = permission.permission_id || permission.id;
                            return (
                              <tr key={permission.id}>
                                <td>
                                  <Form.Check
                                    type="checkbox"
                                    checked={permissionsToRemove.includes(permId)}
                                    onChange={() => togglePermissionToRemove(permId)}
                                  />
                                </td>
                                <td>
                                  <div className="d-flex flex-column">
                                    Permission {permission.description || 'Aucune description'}
                                    {/* <strong className="text-danger">{permission.name}</strong> */}
                                    <small className="text-muted">{permission.display_name}</small>
                                    <small className="text-muted">ID: {permId}</small>
                                  </div>
                                </td>
                                <td><small>{permission.description || 'Aucune description'}</small></td>
                                <td><Badge bg="info">{formatGroupName(permission.group)}</Badge></td>
                                <td><Badge bg="warning" text="dark">{permission.action}</Badge></td>
                              </tr>
                            );
                          })}
                      </tbody>
                    </Table>
                  </div>
                  
                  {/* Bouton de retrait dans le footer du tab */}
                  <div className="mt-3 pt-2 border-top d-flex justify-content-end">
                    <Button
                      variant="danger"
                      onClick={handleRemovePermissions}
                      disabled={removingPermissions || permissionsToRemove.length === 0}
                    >
                      {removingPermissions ? (
                        <><Spinner animation="border" size="sm" className="me-2" />Retrait en cours...</>
                      ) : (
                        <><Trash className="me-2" size={14} />Retirer {permissionsToRemove.length} permission(s)</>
                      )}
                    </Button>
                  </div>
                </>
              )}
            </div>
          </Tab>
        </Tabs>
        
        {/* Résumé des sélections */}
        <div className="mt-3 pt-2 border-top">
          <small className="text-muted">
            <strong>{selectedPermissions.length}</strong> permission(s) assignée(s) à ce rôle
          </small>
        </div>
      </div>
    )}
  </Modal.Body>
  <Modal.Footer>
    <Button 
      variant="secondary" 
      onClick={() => {
        setShowUserPermissionsModal(false);
        setSelectedRole(null);
        setSelectedPermissions([]);
        setPermissionsToRemove([]);
        setPermissionSearchKeyword('');
        setPermissionCurrentPage(1);
      }}
    >
      Fermer
    </Button>
  </Modal.Footer>
</Modal>

        {/* Modal de détails des rôles et permissions d'un utilisateur */}
        <Modal 
          show={showUserPermissionsModal && selectedUserForModal} 
          onHide={() => {
            setShowUserPermissionsModal(false);
            setSelectedUserForModal(null);
            setUserRolesDetails([]);
            setRolePermissionsMap({});
          }} 
          size="xl" 
          centered
        >
          <Modal.Header closeButton className="bg-info text-white">
            <Modal.Title>
              <PersonBadge className="me-2" />
              Rôles et Permissions - {selectedUserForModal?.full_name || 
                (selectedUserForModal?.admin_fname + ' ' + selectedUserForModal?.admin_lname) || 
                'Utilisateur'}
            </Modal.Title>
          </Modal.Header>
          <Modal.Body style={{ maxHeight: '70vh', overflowY: 'auto' }}>
            {loadingUserRoles ? (
              <div className="text-center py-4">
                <Spinner animation="border" variant="info" />
                <p className="mt-2">Chargement des données utilisateur...</p>
              </div>
            ) : (
              <Tabs defaultActiveKey="roles" className="mb-3">
                {/* Tab 1: Rôles de l'utilisateur */}
                <Tab eventKey="roles" title={`Rôles (${userRolesDetails.length})`}>
                  {userRolesDetails.length === 0 ? (
                    <div className="text-center py-4">
                      <Shield size={48} className="text-muted mb-3" />
                      <h5>Aucun rôle assigné</h5>
                      <p className="text-muted">
                        Cet utilisateur n'a pas encore de rôles.
                      </p>
                    </div>
                  ) : (
                    <Row>
                      {userRolesDetails.map(role => (
                        <Col md={6} key={role.id} className="mb-3">
                          <Card className="border-primary h-100">
                            <Card.Header className="bg-primary text-white py-2">
                              <div className="d-flex align-items-center">
                                <Shield className="me-2" />
                                <strong>{role.display_name || role.name}</strong>
                              </div>
                            </Card.Header>
                            <Card.Body>
                              <p className="text-muted small mb-2">
                                {role.description || 'Aucune description'}
                              </p>
                              <div className="d-flex justify-content-between align-items-center">
                                <Badge bg={getScopeBadge(role.scope)}>
                                  Scope: {role.scope}
                                </Badge>
                                {role.assigned_at && (
                                  <small className="text-muted">
                                    Assigné le: {new Date(role.assigned_at).toLocaleDateString('fr-FR')}
                                  </small>
                                )}
                              </div>
                              
                              {/* Afficher quelques permissions en aperçu */}
                              {rolePermissionsMap[role.id] && rolePermissionsMap[role.id].length > 0 && (
                                <div className="mt-3">
                                  <small className="text-muted">
                                    <Key className="me-1" size={12} />
                                    {rolePermissionsMap[role.id].length} permission(s)
                                  </small>
                                  <div className="mt-1">
                                    {rolePermissionsMap[role.id].slice(0, 3).map(perm => (
                                      <Badge 
                                        key={perm.id} 
                                        bg="info" 
                                        className="me-1 mb-1"
                                        style={{ fontSize: '0.7rem' }}
                                      >
                                        {perm.display_name || perm.name}
                                      </Badge>
                                    ))}
                                    {rolePermissionsMap[role.id].length > 3 && (
                                      <Badge bg="secondary" style={{ fontSize: '0.7rem' }}>
                                        +{rolePermissionsMap[role.id].length - 3}
                                      </Badge>
                                    )}
                                  </div>
                                </div>
                              )}
                            </Card.Body>
                          </Card>
                        </Col>
                      ))}
                    </Row>
                  )}
                </Tab>

                {/* Tab 2: Toutes les permissions de l'utilisateur */}
                <Tab eventKey="all-permissions" title={`Toutes les permissions (${getUserUniquePermissions().length})`}>
                  {loadingRolePermissions ? (
                    <div className="text-center py-4">
                      <Spinner animation="border" variant="info" />
                      <p className="mt-2">Chargement des permissions...</p>
                    </div>
                  ) : getUserUniquePermissions().length === 0 ? (
                    <div className="text-center py-4">
                      <Key size={48} className="text-muted mb-3" />
                      <h5>Aucune permission</h5>
                      <p className="text-muted">
                        Cet utilisateur n'a pas de permissions via ses rôles.
                      </p>
                    </div>
                  ) : (
                    <div>
                      {Object.entries(getGroupedUserPermissions()).map(([group, perms]) => (
                        <Card key={group} className="mb-3">
                          <Card.Header className="bg-light">
                            <strong>{formatGroupName(group)}</strong>
                            <Badge bg="info" className="ms-2">{perms.length}</Badge>
                          </Card.Header>
                          <Card.Body>
                            <Row>
                              {perms.map(perm => (
                                <Col md={6} key={perm.id} className="mb-2">
                                  <div className="d-flex align-items-start">
                                    <CheckCircle className="text-success me-2 mt-1" size={16} />
                                    <div>
                                      <strong>{perm.display_name || perm.name}</strong>
                                      <br />
                                      <small className="text-muted">{perm.description || perm.name}</small>
                                      <div className="mt-1">
                                        <Badge bg="info" className="me-1">{perm.action}</Badge>
                                        <Badge bg={getScopeBadge(perm.scope)}>{perm.scope}</Badge>
                                      </div>
                                    </div>
                                  </div>
                                </Col>
                              ))}
                            </Row>
                          </Card.Body>
                        </Card>
                      ))}
                    </div>
                  )}
                </Tab>

                {/* Tab 3: Permissions par rôle */}
                <Tab eventKey="by-role" title="Par rôle">
                  {loadingRolePermissions ? (
                    <div className="text-center py-4">
                      <Spinner animation="border" variant="info" />
                      <p className="mt-2">Chargement des permissions...</p>
                    </div>
                  ) : userRolesDetails.length === 0 ? (
                    <div className="text-center py-4">
                      <Shield size={48} className="text-muted mb-3" />
                      <h5>Aucun rôle assigné</h5>
                    </div>
                  ) : (
                    <Accordion defaultActiveKey="0">
                      {userRolesDetails.map((role, index) => (
                        <Accordion.Item eventKey={index.toString()} key={role.id}>
                          <Accordion.Header>
                            <div className="d-flex align-items-center w-100">
                              <Shield className="me-2 text-primary" />
                              <strong>{role.display_name || role.name}</strong>
                              <Badge bg={getScopeBadge(role.scope)} className="ms-2">
                                {role.scope}
                              </Badge>
                              <Badge bg="info" className="ms-2">
                                {rolePermissionsMap[role.id]?.length || 0} permissions
                              </Badge>
                            </div>
                          </Accordion.Header>
                          <Accordion.Body>
                            {!rolePermissionsMap[role.id] || rolePermissionsMap[role.id].length === 0 ? (
                              <p className="text-muted text-center py-3">
                                Aucune permission pour ce rôle
                              </p>
                            ) : (
                              <div>
                                {/* Grouper les permissions par catégorie */}
                                {Object.entries(
                                  rolePermissionsMap[role.id].reduce((acc, perm) => {
                                    const group = perm.group || 'general';
                                    if (!acc[group]) acc[group] = [];
                                    acc[group].push(perm);
                                    return acc;
                                  }, {})
                                ).map(([group, perms]) => (
                                  <div key={group} className="mb-3">
                                    <h6 className="text-muted mb-2">
                                      {formatGroupName(group)}
                                      <Badge bg="secondary" className="ms-2">{perms.length}</Badge>
                                    </h6>
                                    <Row>
                                      {perms.map(perm => (
                                        <Col md={6} key={perm.id} className="mb-2">
                                          <Card className="border-light bg-light">
                                            <Card.Body className="py-2">
                                              <div className="d-flex align-items-center">
                                                <Key className="text-info me-2" size={14} />
                                                <div>
                                                  <small>
                                                    <strong>{perm.display_name || perm.name}</strong>
                                                  </small>
                                                  <div>
                                                    <Badge bg="info" size="sm" className="me-1" style={{ fontSize: '0.6rem' }}>
                                                      {perm.action}
                                                    </Badge>
                                                    <Badge bg={getScopeBadge(perm.scope)} style={{ fontSize: '0.6rem' }}>
                                                      {perm.scope}
                                                    </Badge>
                                                  </div>
                                                </div>
                                              </div>
                                            </Card.Body>
                                          </Card>
                                        </Col>
                                      ))}
                                    </Row>
                                  </div>
                                ))}
                              </div>
                            )}
                          </Accordion.Body>
                        </Accordion.Item>
                      ))}
                    </Accordion>
                  )}
                </Tab>
              </Tabs>
            )}
          </Modal.Body>
          <Modal.Footer>
            <Button 
              variant="secondary" 
              onClick={() => {
                setShowUserPermissionsModal(false);
                setSelectedUserForModal(null);
                setUserRolesDetails([]);
                setRolePermissionsMap({});
              }}
            >
              Fermer
            </Button>
          </Modal.Footer>
        </Modal>

        {/* Modal d'assignation de rôle à un utilisateur */}
        <Modal show={showAssignModal} onHide={() => setShowAssignModal(false)} centered>
          <Modal.Header closeButton className="bg-success text-white">
            <Modal.Title>
              <PersonBadge className="me-2" />
              Assigner un rôle
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Form>
              <Form.Group className="mb-3">
                <Form.Label>Sélectionner un utilisateur</Form.Label>
                <Form.Select
                  value={selectedUser || ""}
                  onChange={(e) => setSelectedUser(e.target.value)}
                >
                  <option value="">Choisir un utilisateur</option>
                  {users.map(user => (
                    <option key={user.user_id} value={user.user_id}>
                      {user.full_name || user.admin_fname + ' ' + user.admin_lname} - {user.email}
                    </option>
                  ))}
                </Form.Select>
              </Form.Group>
              
              <Form.Group className="mb-3">
                <Form.Label>Sélectionner un rôle</Form.Label>
                <Form.Select
                  value={selectedUserRole || ""}
                  onChange={(e) => setSelectedUserRole(parseInt(e.target.value))}
                >
                  <option value="">Choisir un rôle</option>
                  {roles.map(role => (
                    <option key={role.id} value={role.id}>
                      {role.display_name} ({role.scope})
                    </option>
                  ))}
                </Form.Select>
              </Form.Group>
            </Form>
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={() => setShowAssignModal(false)}>
              Annuler
            </Button>
            <Button 
              variant="success" 
              onClick={handleAssignUserRole}
              disabled={saving || !selectedUser || !selectedUserRole}
            >
              {saving ? (
                <>
                  <Spinner animation="border" size="sm" className="me-2" />
                  Assignation...
                </>
              ) : (
                <>
                  <Shield className="me-2" />
                  Assigner le rôle
                </>
              )}
            </Button>
          </Modal.Footer>
        </Modal>

        {/* Modal de confirmation de suppression */}
        <Modal show={showDeleteModal} onHide={() => setShowDeleteModal(false)} centered>
          <Modal.Header closeButton className="bg-danger text-white">
            <Modal.Title>
              <Trash className="me-2" />
              Confirmer la suppression
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <div className="text-center">
              <ExclamationTriangle size={48} className="text-danger mb-3" />
              <h5>Êtes-vous sûr de vouloir supprimer ce rôle ?</h5>
              {selectedRole && (
                <div className="mt-3 p-3 bg-light rounded">
                  <strong>{selectedRole.display_name}</strong>
                  <br />
                  <small className="text-muted">{selectedRole.description}</small>
                </div>
              )}
              <p className="text-muted mt-3">
                Cette action est irréversible. Les utilisateurs ayant ce rôle perdront leurs permissions associées.
              </p>
            </div>
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={() => setShowDeleteModal(false)}>
              Annuler
            </Button>
            <Button 
              variant="danger" 
              onClick={handleDeleteRole}
              disabled={saving}
            >
              {saving ? (
                <>
                  <Spinner animation="border" size="sm" className="me-2" />
                  Suppression...
                </>
              ) : (
                <>
                  <Trash className="me-2" />
                  Supprimer définitivement
                </>
              )}
            </Button>
          </Modal.Footer>
        </Modal>

         <style>{`
.matrix-table {
  font-size: 0.9rem;
}

.matrix-table th {
  vertical-align: middle;
  text-align: center;
  font-weight: 600;
}

.matrix-table td {
  vertical-align: middle;
}

.matrix-table .table-secondary {
  background-color: #e9ecef;
}

.matrix-table .badge {
  font-weight: normal;
}

.matrix-table tr:hover td {
  background-color: rgba(0, 123, 255, 0.05);
}

/* Animation pour les icônes */
.matrix-table .badge-pill {
  transition: transform 0.2s;
}

.matrix-table .badge-pill:hover {
  transform: scale(1.1);
}

`}</style>

        <Footer />
      </div>
    </React.Fragment>
  );
}